// // // import React, { useEffect, useState } from "react";
// // // import axios from "axios";

// // // const API = "https://bmtvendorvendorfinal.onrender.com/api/vendor/apartment";

// // // const AMENITIES = ["WiFi", "AC", "TV", "Parking", "Lift", "Geyser", "Power Backup", "Security", "CCTV", "Intercom", "Gym", "Swimming Pool", "Garden", "Club House", "Play Area", "Visitor Parking"];
// // // const APARTMENT_TYPES = ["Studio", "1BHK", "2BHK", "3BHK", "4BHK", "Penthouse"];
// // // const FURNISHING_TYPES = ["Fully Furnished", "Semi Furnished", "Unfurnished"];
// // // const ROOM_TYPES = ["Entire Apartment", "Private Room", "Shared Room"];
// // // const MEAL_PLANS = ["None", "Breakfast Only", "Half Board", "Full Board", "All Inclusive"];
// // // const CANCELLATION = ["Flexible", "Moderate", "Strict", "Non-Refundable"];

// // // const DEFAULT_RULES = { smoking: false, alcohol: false, parties: false, loudMusic: false, unmarriedCouples: false, localIdAllowed: false };
// // // const RULE_LABELS = { smoking: "Smoking", alcohol: "Alcohol", parties: "Parties", loudMusic: "Loud Music", unmarriedCouples: "Unmarried Couples", localIdAllowed: "Local ID Accepted" };

// // // const DEFAULT_FORM = {
// // //   apartmentName: "", propertyType: "Apartment", description: "", hostName: "",
// // //   phone: "", altPhone: "", email: "",
// // //   country: "India", state: "", city: "", area: "", address: "", pincode: "", landmark: "",
// // //   lat: "", lng: "",
// // //   buildingName: "", towerName: "", floorNumber: "", totalFloors: "", flatNumber: "", societyName: "",
// // //   apartmentType: "1BHK", furnishing: "Fully Furnished",
// // //   carpetArea: "", superArea: "",
// // //   bedrooms: "", hall: "", kitchen: "", bathrooms: "", balcony: "",
// // //   maxGuests: "", beds: "",
// // //   extraMattressAllowed: false, childrenAllowed: false, petsAllowed: false,
// // //   kitchenAvailable: false, selfCookingAllowed: false, vegFoodAvailable: false, nonVegAllowed: false,
// // //   basePrice: "", monthlyPrice: "", weekendPrice: "", extraGuestPrice: "", cleaningFee: "", securityDeposit: "",
// // //   checkInTime: "14:00", checkOutTime: "11:00",
// // //   availableFrom: "", availableTo: "",
// // //   roomType: "Entire Apartment", mealPlan: "None", cancellationPolicy: "Moderate", notes: "",
// // // };

// // // export default function VendorApartment() {
// // //   const token = localStorage.getItem("token");
// // //   const authHeaders = { headers: { Authorization: `Bearer ${token}` } };

// // //   const [apartments, setApartments] = useState([]);
// // //   const [filtered, setFiltered] = useState([]);
// // //   const [form, setForm] = useState(DEFAULT_FORM);
// // //   const [rules, setRules] = useState(DEFAULT_RULES);
// // //   const [amenities, setAmenities] = useState([]);
// // //   const [images, setImages] = useState([]);
// // //   const [previews, setPreviews] = useState([]);
// // //   const [editId, setEditId] = useState(null);
// // //   const [showModal, setShowModal] = useState(false);
// // //   const [activeTab, setActiveTab] = useState("basic");
// // //   const [loading, setLoading] = useState(false);
// // //   const [submitting, setSubmitting] = useState(false);
// // //   const [error, setError] = useState("");
// // //   const [success, setSuccess] = useState("");
// // //   const [search, setSearch] = useState("");
// // //   const [filterStatus, setFilterStatus] = useState("");
// // //   const [deleteConfirm, setDeleteConfirm] = useState(null);

// // //   useEffect(() => { if (!token) window.location.href = "/"; else fetchApartments(); }, []);
// // //   useEffect(() => { applyFilters(); }, [apartments, search, filterStatus]);

// // //   const applyFilters = () => {
// // //     let res = [...apartments];
// // //     if (search) res = res.filter(a => a.apartmentName?.toLowerCase().includes(search.toLowerCase()) || a.city?.toLowerCase().includes(search.toLowerCase()));
// // //     if (filterStatus) res = res.filter(a => a.status === filterStatus);
// // //     setFiltered(res);
// // //   };

// // //   const fetchApartments = async () => {
// // //     setLoading(true);
// // //     try {
// // //       const res = await axios.get(API, authHeaders);
// // //       setApartments(res.data.data || []);
// // //     } catch (e) { setError("Failed to load apartments"); }
// // //     setLoading(false);
// // //   };

// // //   const f = (k, v) => setForm(p => ({ ...p, [k]: v }));
// // //   const toggleAmenity = a => setAmenities(p => p.includes(a) ? p.filter(x => x !== a) : [...p, a]);
// // //   const toggleRule = k => setRules(p => ({ ...p, [k]: !p[k] }));

// // //   const handleImages = e => {
// // //     const files = Array.from(e.target.files);
// // //     const valid = files.filter(f => f.type.startsWith("image/") && f.size <= 5 * 1024 * 1024);
// // //     if (images.length + valid.length > 10) { setError("Max 10 images"); return; }
// // //     setImages(p => [...p, ...valid]);
// // //     setPreviews(p => [...p, ...valid.map(f => URL.createObjectURL(f))]);
// // //   };

// // //   const removeImage = i => {
// // //     setImages(p => p.filter((_, idx) => idx !== i));
// // //     setPreviews(p => p.filter((_, idx) => idx !== i));
// // //   };

// // //   const handleSubmit = async e => {
// // //     e.preventDefault();
// // //     if (!form.apartmentName || !form.city || !form.basePrice) { setError("Fill all required fields"); return; }
// // //     if (!editId && images.length === 0) { setError("Upload at least one image"); return; }
// // //     setSubmitting(true); setError("");

// // //     const data = new FormData();
// // //     Object.entries(form).forEach(([k, v]) => data.append(k, v));
// // //     data.append("amenities", JSON.stringify(amenities));
// // //     data.append("houseRules", JSON.stringify(rules));
// // //     images.forEach(img => data.append("images", img));

// // //     const cfg = { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } };
// // //     try {
// // //       if (editId) await axios.put(`${API}/${editId}`, data, cfg);
// // //       else await axios.post(API, data, cfg);
// // //       setSuccess(editId ? "Apartment updated!" : "Apartment added successfully!");
// // //       closeModal(); fetchApartments();
// // //       setTimeout(() => setSuccess(""), 3000);
// // //     } catch (e) { setError(e.response?.data?.message || "Operation failed"); }
// // //     setSubmitting(false);
// // //   };

// // //   const startEdit = a => {
// // //     setEditId(a._id);
// // //     setForm({
// // //       apartmentName: a.apartmentName || "", propertyType: a.propertyType || "Apartment",
// // //       description: a.description || "", hostName: a.hostName || "",
// // //       phone: a.phone || "", altPhone: a.altPhone || "", email: a.email || "",
// // //       country: a.country || "India", state: a.state || "", city: a.city || "",
// // //       area: a.area || "", address: a.address || "", pincode: a.pincode || "", landmark: a.landmark || "",
// // //       lat: a.mapLocation?.lat || "", lng: a.mapLocation?.lng || "",
// // //       buildingName: a.buildingName || "", towerName: a.towerName || "",
// // //       floorNumber: a.floorNumber || "", totalFloors: a.totalFloors || "",
// // //       flatNumber: a.flatNumber || "", societyName: a.societyName || "",
// // //       apartmentType: a.apartmentType || "1BHK", furnishing: a.furnishing || "Fully Furnished",
// // //       carpetArea: a.carpetArea || "", superArea: a.superArea || "",
// // //       bedrooms: a.bedrooms || "", hall: a.hall || "", kitchen: a.kitchen || "",
// // //       bathrooms: a.bathrooms || "", balcony: a.balcony || "",
// // //       maxGuests: a.maxGuests || "", beds: a.beds || "",
// // //       extraMattressAllowed: a.extraMattressAllowed || false,
// // //       childrenAllowed: a.childrenAllowed || false, petsAllowed: a.petsAllowed || false,
// // //       kitchenAvailable: a.kitchenAvailable || false, selfCookingAllowed: a.selfCookingAllowed || false,
// // //       vegFoodAvailable: a.vegFoodAvailable || false, nonVegAllowed: a.nonVegAllowed || false,
// // //       basePrice: a.pricing?.basePrice || "", monthlyPrice: a.pricing?.monthlyPrice || "",
// // //       weekendPrice: a.pricing?.weekendPrice || "", extraGuestPrice: a.pricing?.extraGuestPrice || "",
// // //       cleaningFee: a.pricing?.cleaningFee || "", securityDeposit: a.pricing?.securityDeposit || "",
// // //       checkInTime: a.checkInTime || "14:00", checkOutTime: a.checkOutTime || "11:00",
// // //       availableFrom: a.availableFrom?.split("T")[0] || "", availableTo: a.availableTo?.split("T")[0] || "",
// // //       roomType: a.roomType || "Entire Apartment", mealPlan: a.mealPlan || "None",
// // //       cancellationPolicy: a.cancellationPolicy || "Moderate", notes: a.notes || "",
// // //     });
// // //     setAmenities(a.amenities || []);
// // //     setRules(a.houseRules || DEFAULT_RULES);
// // //     setImages([]); setPreviews(a.images || []);
// // //     setShowModal(true); setActiveTab("basic");
// // //   };

// // //   const handleDelete = async id => {
// // //     try {
// // //       await axios.delete(`${API}/${id}`, authHeaders);
// // //       setDeleteConfirm(null); fetchApartments();
// // //       setSuccess("Apartment deleted."); setTimeout(() => setSuccess(""), 3000);
// // //     } catch (e) { setError("Delete failed"); }
// // //   };

// // //   const handleToggle = async a => {
// // //     try {
// // //       await axios.patch(`${API}/${a._id}/toggle`, {}, authHeaders);
// // //       fetchApartments();
// // //     } catch (e) { setError(e.response?.data?.message || "Toggle failed"); }
// // //   };

// // //   const closeModal = () => { setShowModal(false); setEditId(null); setForm(DEFAULT_FORM); setRules(DEFAULT_RULES); setAmenities([]); setImages([]); setPreviews([]); setActiveTab("basic"); setError(""); };

// // //   const tabs = [
// // //     { id: "basic", label: "Basic Info", icon: "🏢" },
// // //     { id: "location", label: "Location", icon: "📍" },
// // //     { id: "building", label: "Building", icon: "🏗️" },
// // //     { id: "details", label: "Details", icon: "📐" },
// // //     { id: "amenities", label: "Amenities", icon: "✨" },
// // //     { id: "food", label: "Food", icon: "🍽️" },
// // //     { id: "pricing", label: "Pricing", icon: "💰" },
// // //     { id: "rules", label: "Rules", icon: "📋" },
// // //     { id: "media", label: "Photos", icon: "📸" },
// // //   ];

// // //   const statusColor = s => ({ approved: "#0369a1", pending: "#d97706", rejected: "#dc2626", inactive: "#6b7280" }[s] || "#6b7280");
// // //   const statusBg = s => ({ approved: "#e0f2fe", pending: "#fef3c7", rejected: "#fee2e2", inactive: "#f3f4f6" }[s] || "#f3f4f6");

// // //   return (
// // //     <div style={S.page}>
// // //       <style>{`
// // //         @import url('https://fonts.googleapis.com/css2?family=Syne:wght@600;700;800&family=Outfit:wght@400;500;600&display=swap');
// // //         * { box-sizing: border-box; margin: 0; padding: 0; }
// // //         body { font-family: 'Outfit', sans-serif; }
// // //         .ap-row:hover { background: #f0f9ff !important; }
// // //         .ap-tab:hover { background: #e0f2fe !important; }
// // //         .ap-tab.active { background: #0369a1 !important; color: white !important; }
// // //         .ap-chip { cursor: pointer; transition: all .2s; }
// // //         .ap-chip:hover { border-color: #0369a1 !important; color: #0369a1 !important; }
// // //         .ap-chip.on { background: #0369a1 !important; color: white !important; border-color: #0369a1 !important; }
// // //         input:focus, select:focus, textarea:focus { outline: none; border-color: #0369a1 !important; box-shadow: 0 0 0 3px rgba(3,105,161,0.12) !important; }
// // //         .ap-submit:hover { background: #075985 !important; }
// // //         .ap-del:hover { background: #fef2f2 !important; }
// // //         ::-webkit-scrollbar { width: 6px; } ::-webkit-scrollbar-track { background: #f1f5f9; } ::-webkit-scrollbar-thumb { background: #bae6fd; border-radius: 3px; }
// // //       `}</style>

// // //       {/* Header */}
// // //       <div style={S.header}>
// // //         <div>
// // //           <h1 style={S.title}>Apartment Listings</h1>
// // //           <p style={S.subtitle}>{apartments.length} apartments · Manage your properties</p>
// // //         </div>
// // //         <button onClick={() => setShowModal(true)} style={S.addBtn}>+ Add Apartment</button>
// // //       </div>

// // //       {/* Toasts */}
// // //       {success && <div style={S.toast("blue")}>{success}</div>}
// // //       {error && !showModal && <div style={S.toast("red")}>{error} <button onClick={() => setError("")} style={{ background: "none", border: "none", color: "inherit", cursor: "pointer", marginLeft: 8 }}>✕</button></div>}

// // //       {/* Filters */}
// // //       <div style={S.filterBar}>
// // //         <input placeholder="🔍 Search by name or city..." value={search} onChange={e => setSearch(e.target.value)} style={S.searchInput} />
// // //         <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)} style={S.filterSelect}>
// // //           <option value="">All Status</option>
// // //           <option value="pending">Pending</option>
// // //           <option value="approved">Approved</option>
// // //           <option value="rejected">Rejected</option>
// // //           <option value="inactive">Inactive</option>
// // //         </select>
// // //         {(search || filterStatus) && <button onClick={() => { setSearch(""); setFilterStatus(""); }} style={S.clearBtn}>Clear</button>}
// // //         <span style={S.filterCount}>{filtered.length} of {apartments.length}</span>
// // //       </div>

// // //       {/* Table */}
// // //       {loading ? (
// // //         <div style={S.center}><div style={S.spinner} /></div>
// // //       ) : filtered.length === 0 ? (
// // //         <div style={S.empty}>
// // //           <div style={{ fontSize: 64, marginBottom: 16 }}>🏢</div>
// // //           <p style={{ fontSize: 20, fontWeight: 600, color: "#374151" }}>No apartments found</p>
// // //           <p style={{ color: "#9ca3af", marginTop: 8 }}>Add your first apartment to get started</p>
// // //         </div>
// // //       ) : (
// // //         <div style={S.tableWrap}>
// // //           <table style={S.table}>
// // //             <thead>
// // //               <tr style={{ background: "#f0f9ff" }}>
// // //                 {["Apartment", "Location", "Type & Size", "Pricing", "Amenities", "Status", "Actions"].map(h => (
// // //                   <th key={h} style={S.th}>{h}</th>
// // //                 ))}
// // //               </tr>
// // //             </thead>
// // //             <tbody>
// // //               {filtered.map(a => (
// // //                 <tr key={a._id} className="ap-row" style={S.tr}>
// // //                   <td style={S.td}>
// // //                     <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
// // //                       <div style={S.imgWrap}>
// // //                         {a.images?.[0] ? <img src={a.images[0]} alt="" style={S.thumb} onError={e => e.target.style.display = "none"} /> : <span style={{ fontSize: 28 }}>🏢</span>}
// // //                       </div>
// // //                       <div>
// // //                         <div style={{ fontWeight: 600, fontSize: 14, color: "#111827" }}>{a.apartmentName}</div>
// // //                         {a.societyName && <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>{a.societyName}</div>}
// // //                         {a.description && <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2, maxWidth: 200 }}>{a.description.substring(0, 55)}{a.description.length > 55 ? "…" : ""}</div>}
// // //                       </div>
// // //                     </div>
// // //                   </td>
// // //                   <td style={S.td}>
// // //                     <div style={{ fontSize: 13 }}>
// // //                       <div style={{ fontWeight: 500 }}>{a.city}{a.state ? `, ${a.state}` : ""}</div>
// // //                       {a.area && <div style={{ color: "#9ca3af", fontSize: 12 }}>{a.area}</div>}
// // //                       {a.floorNumber && <div style={{ color: "#9ca3af", fontSize: 12 }}>Floor {a.floorNumber}{a.totalFloors ? `/${a.totalFloors}` : ""}</div>}
// // //                     </div>
// // //                   </td>
// // //                   <td style={S.td}>
// // //                     <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
// // //                       <span style={S.typeBadge}>{a.apartmentType || "Apartment"}</span>
// // //                       {a.furnishing && <span style={{ fontSize: 11, color: "#6b7280" }}>{a.furnishing}</span>}
// // //                       <span style={{ fontSize: 11, color: "#9ca3af" }}>
// // //                         {[a.bedrooms && `${a.bedrooms}BR`, a.bathrooms && `${a.bathrooms}BA`, a.maxGuests && `${a.maxGuests} guests`].filter(Boolean).join(" · ")}
// // //                       </span>
// // //                     </div>
// // //                   </td>
// // //                   <td style={S.td}>
// // //                     <div style={{ fontWeight: 700, fontSize: 15, color: "#0369a1" }}>₹{a.pricing?.basePrice?.toLocaleString("en-IN") || "—"}</div>
// // //                     <div style={{ fontSize: 11, color: "#9ca3af" }}>per night</div>
// // //                     {a.pricing?.monthlyPrice && <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>₹{Number(a.pricing.monthlyPrice).toLocaleString("en-IN")}/mo</div>}
// // //                   </td>
// // //                   <td style={S.td}>
// // //                     <div style={{ display: "flex", flexWrap: "wrap", gap: 4, maxWidth: 160 }}>
// // //                       {(a.amenities || []).slice(0, 3).map((am, i) => <span key={i} style={S.pill}>{am}</span>)}
// // //                       {(a.amenities?.length || 0) > 3 && <span style={S.pill}>+{a.amenities.length - 3}</span>}
// // //                       {!a.amenities?.length && <span style={{ color: "#9ca3af", fontSize: 12 }}>None</span>}
// // //                     </div>
// // //                   </td>
// // //                   <td style={S.td}>
// // //                     <span style={{ ...S.statusBadge, background: statusBg(a.status), color: statusColor(a.status) }}>
// // //                       {a.status || "pending"}
// // //                     </span>
// // //                     {(a.status === "approved" || a.status === "inactive") && (
// // //                       <button onClick={() => handleToggle(a)} style={{ display: "block", marginTop: 6, fontSize: 11, background: "none", border: "1px solid #d1d5db", borderRadius: 4, padding: "2px 8px", cursor: "pointer", color: "#6b7280" }}>
// // //                         {a.status === "approved" ? "Deactivate" : "Activate"}
// // //                       </button>
// // //                     )}
// // //                   </td>
// // //                   <td style={S.td}>
// // //                     <div style={{ display: "flex", gap: 6 }}>
// // //                       <button onClick={() => startEdit(a)} style={S.editBtn} title="Edit">✏️</button>
// // //                       <button onClick={() => setDeleteConfirm(a._id)} className="ap-del" style={S.deleteBtn} title="Delete">🗑️</button>
// // //                     </div>
// // //                   </td>
// // //                 </tr>
// // //               ))}
// // //             </tbody>
// // //           </table>
// // //         </div>
// // //       )}

// // //       {/* Delete Confirm */}
// // //       {deleteConfirm && (
// // //         <div style={S.overlay} onClick={() => setDeleteConfirm(null)}>
// // //           <div style={{ ...S.modal, maxWidth: 400, padding: 32, textAlign: "center" }} onClick={e => e.stopPropagation()}>
// // //             <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
// // //             <h3 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Delete Apartment?</h3>
// // //             <p style={{ color: "#6b7280", marginBottom: 24 }}>This action cannot be undone.</p>
// // //             <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
// // //               <button onClick={() => setDeleteConfirm(null)} style={S.cancelBtn}>Cancel</button>
// // //               <button onClick={() => handleDelete(deleteConfirm)} style={{ ...S.addBtn, background: "#dc2626" }}>Delete</button>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       )}

// // //       {/* MODAL */}
// // //       {showModal && (
// // //         <div style={S.overlay} onClick={closeModal}>
// // //           <div style={S.modal} onClick={e => e.stopPropagation()}>
// // //             <div style={S.modalHead}>
// // //               <div>
// // //                 <h2 style={{ fontFamily: "'Syne', sans-serif", fontSize: 24, fontWeight: 800 }}>
// // //                   {editId ? "Edit Apartment" : "Add New Apartment"}
// // //                 </h2>
// // //                 <p style={{ color: "#6b7280", fontSize: 13, marginTop: 4 }}>Fill in all the details carefully</p>
// // //               </div>
// // //               <button onClick={closeModal} style={S.closeBtn}>✕</button>
// // //             </div>

// // //             {error && <div style={{ margin: "0 32px", padding: "10px 16px", background: "#fee2e2", color: "#dc2626", borderRadius: 8, fontSize: 14 }}>{error}</div>}

// // //             {/* Tabs */}
// // //             <div style={S.tabsRow}>
// // //               {tabs.map(t => (
// // //                 <button key={t.id} className={`ap-tab ${activeTab === t.id ? "active" : ""}`} onClick={() => setActiveTab(t.id)} style={S.tabBtn}>
// // //                   {t.icon} {t.label}
// // //                 </button>
// // //               ))}
// // //             </div>

// // //             <form onSubmit={handleSubmit}>
// // //               <div style={S.formBody}>

// // //                 {/* ── BASIC INFO ── */}
// // //                 {activeTab === "basic" && (
// // //                   <div style={S.grid2}>
// // //                     <div style={{ gridColumn: "1/-1" }}>
// // //                       <Label>Apartment Name *</Label>
// // //                       <Input value={form.apartmentName} onChange={v => f("apartmentName", v)} placeholder="e.g., Skyline 2BHK Apartment" required />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Host Name</Label>
// // //                       <Input value={form.hostName} onChange={v => f("hostName", v)} placeholder="Owner / host name" />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Phone</Label>
// // //                       <Input value={form.phone} onChange={v => f("phone", v)} placeholder="+91 XXXXX XXXXX" />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Alternate Phone</Label>
// // //                       <Input value={form.altPhone} onChange={v => f("altPhone", v)} placeholder="+91 XXXXX XXXXX" />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Email</Label>
// // //                       <Input type="email" value={form.email} onChange={v => f("email", v)} placeholder="host@email.com" />
// // //                     </div>
// // //                     <div style={{ gridColumn: "1/-1" }}>
// // //                       <Label>Description</Label>
// // //                       <textarea value={form.description} onChange={e => f("description", e.target.value)} placeholder="Describe your apartment — layout, views, neighbourhood, nearby attractions..." style={{ ...S.input, minHeight: 100, resize: "vertical" }} />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Room Type</Label>
// // //                       <Select value={form.roomType} onChange={v => f("roomType", v)} options={ROOM_TYPES} />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Meal Plan</Label>
// // //                       <Select value={form.mealPlan} onChange={v => f("mealPlan", v)} options={MEAL_PLANS} />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Cancellation Policy</Label>
// // //                       <Select value={form.cancellationPolicy} onChange={v => f("cancellationPolicy", v)} options={CANCELLATION} />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Internal Notes</Label>
// // //                       <Input value={form.notes} onChange={v => f("notes", v)} placeholder="Notes (optional)" />
// // //                     </div>
// // //                   </div>
// // //                 )}

// // //                 {/* ── LOCATION ── */}
// // //                 {activeTab === "location" && (
// // //                   <div style={S.grid2}>
// // //                     <div style={{ gridColumn: "1/-1" }}>
// // //                       <Label>Full Address *</Label>
// // //                       <Input value={form.address} onChange={v => f("address", v)} placeholder="Flat no, building, street..." required />
// // //                     </div>
// // //                     <div>
// // //                       <Label>City *</Label>
// // //                       <Input value={form.city} onChange={v => f("city", v)} placeholder="e.g., Mumbai" required />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Area / Locality</Label>
// // //                       <Input value={form.area} onChange={v => f("area", v)} placeholder="e.g., Bandra West" />
// // //                     </div>
// // //                     <div>
// // //                       <Label>State</Label>
// // //                       <Input value={form.state} onChange={v => f("state", v)} placeholder="e.g., Maharashtra" />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Pincode</Label>
// // //                       <Input value={form.pincode} onChange={v => f("pincode", v)} placeholder="e.g., 400050" />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Country</Label>
// // //                       <Input value={form.country} onChange={v => f("country", v)} placeholder="India" />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Landmark</Label>
// // //                       <Input value={form.landmark} onChange={v => f("landmark", v)} placeholder="Near XYZ mall" />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Latitude</Label>
// // //                       <Input value={form.lat} onChange={v => f("lat", v)} placeholder="e.g., 19.0760" />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Longitude</Label>
// // //                       <Input value={form.lng} onChange={v => f("lng", v)} placeholder="e.g., 72.8777" />
// // //                     </div>
// // //                   </div>
// // //                 )}

// // //                 {/* ── BUILDING ── */}
// // //                 {activeTab === "building" && (
// // //                   <div style={S.grid2}>
// // //                     <div>
// // //                       <Label>Building Name</Label>
// // //                       <Input value={form.buildingName} onChange={v => f("buildingName", v)} placeholder="e.g., Oberoi Splendor" />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Society / Complex Name</Label>
// // //                       <Input value={form.societyName} onChange={v => f("societyName", v)} placeholder="e.g., Green Park Society" />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Tower Name</Label>
// // //                       <Input value={form.towerName} onChange={v => f("towerName", v)} placeholder="e.g., Tower A" />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Flat Number</Label>
// // //                       <Input value={form.flatNumber} onChange={v => f("flatNumber", v)} placeholder="e.g., 1204" />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Floor Number</Label>
// // //                       <Input type="number" value={form.floorNumber} onChange={v => f("floorNumber", v)} placeholder="e.g., 12" />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Total Floors in Building</Label>
// // //                       <Input type="number" value={form.totalFloors} onChange={v => f("totalFloors", v)} placeholder="e.g., 25" />
// // //                     </div>
// // //                   </div>
// // //                 )}

// // //                 {/* ── APARTMENT DETAILS ── */}
// // //                 {activeTab === "details" && (
// // //                   <div>
// // //                     <div style={S.grid2}>
// // //                       <div>
// // //                         <Label>Apartment Type</Label>
// // //                         <Select value={form.apartmentType} onChange={v => f("apartmentType", v)} options={APARTMENT_TYPES} />
// // //                       </div>
// // //                       <div>
// // //                         <Label>Furnishing</Label>
// // //                         <Select value={form.furnishing} onChange={v => f("furnishing", v)} options={FURNISHING_TYPES} />
// // //                       </div>
// // //                       <div>
// // //                         <Label>Carpet Area (sq ft)</Label>
// // //                         <Input value={form.carpetArea} onChange={v => f("carpetArea", v)} placeholder="e.g., 850" />
// // //                       </div>
// // //                       <div>
// // //                         <Label>Super Area (sq ft)</Label>
// // //                         <Input value={form.superArea} onChange={v => f("superArea", v)} placeholder="e.g., 1100" />
// // //                       </div>
// // //                     </div>
// // //                     <div style={{ ...S.grid4, marginTop: 20 }}>
// // //                       {[["bedrooms", "Bedrooms"], ["hall", "Hall"], ["kitchen", "Kitchen"], ["bathrooms", "Bathrooms"], ["balcony", "Balcony"], ["maxGuests", "Max Guests"], ["beds", "Beds"]].map(([k, l]) => (
// // //                         <div key={k}>
// // //                           <Label>{l}</Label>
// // //                           <Input type="number" min="0" value={form[k]} onChange={v => f(k, v)} placeholder="0" />
// // //                         </div>
// // //                       ))}
// // //                     </div>
// // //                     <div style={{ marginTop: 24 }}>
// // //                       <Label>Availability & Timings</Label>
// // //                       <div style={{ ...S.grid2, marginTop: 12 }}>
// // //                         {[["availableFrom", "Available From", "date"], ["availableTo", "Available To", "date"], ["checkInTime", "Check-In Time", "time"], ["checkOutTime", "Check-Out Time", "time"]].map(([k, l, t]) => (
// // //                           <div key={k}>
// // //                             <Label>{l}</Label>
// // //                             <Input type={t} value={form[k]} onChange={v => f(k, v)} />
// // //                           </div>
// // //                         ))}
// // //                       </div>
// // //                     </div>
// // //                     <div style={{ marginTop: 24 }}>
// // //                       <Label>Guest Policy</Label>
// // //                       <div style={S.checkGrid}>
// // //                         {[["extraMattressAllowed", "Extra Mattress Allowed"], ["childrenAllowed", "Children Allowed"], ["petsAllowed", "Pets Allowed"]].map(([k, l]) => (
// // //                           <label key={k} style={S.checkLabel}>
// // //                             <input type="checkbox" checked={form[k]} onChange={e => f(k, e.target.checked)} style={{ width: 16, height: 16, accentColor: "#0369a1" }} />
// // //                             {l}
// // //                           </label>
// // //                         ))}
// // //                       </div>
// // //                     </div>
// // //                   </div>
// // //                 )}

// // //                 {/* ── AMENITIES ── */}
// // //                 {activeTab === "amenities" && (
// // //                   <div>
// // //                     <p style={{ color: "#6b7280", fontSize: 14, marginBottom: 16 }}>Select all amenities available in your apartment</p>
// // //                     <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
// // //                       {AMENITIES.map(a => (
// // //                         <button key={a} type="button" className={`ap-chip ${amenities.includes(a) ? "on" : ""}`} onClick={() => toggleAmenity(a)} style={S.chip}>
// // //                           {a}
// // //                         </button>
// // //                       ))}
// // //                     </div>
// // //                     <p style={{ marginTop: 16, fontSize: 13, color: "#9ca3af" }}>{amenities.length} amenities selected</p>
// // //                   </div>
// // //                 )}

// // //                 {/* ── FOOD ── */}
// // //                 {activeTab === "food" && (
// // //                   <div>
// // //                     <p style={{ color: "#6b7280", fontSize: 14, marginBottom: 20 }}>Configure food and kitchen availability</p>
// // //                     <div style={S.checkGrid}>
// // //                       {[["kitchenAvailable", "Kitchen Available"], ["selfCookingAllowed", "Self Cooking Allowed"], ["vegFoodAvailable", "Veg Food Available"], ["nonVegAllowed", "Non-Veg Allowed"]].map(([k, l]) => (
// // //                         <label key={k} style={S.checkLabel}>
// // //                           <input type="checkbox" checked={form[k]} onChange={e => f(k, e.target.checked)} style={{ width: 16, height: 16, accentColor: "#0369a1" }} />
// // //                           {l}
// // //                         </label>
// // //                       ))}
// // //                     </div>
// // //                   </div>
// // //                 )}

// // //                 {/* ── PRICING ── */}
// // //                 {activeTab === "pricing" && (
// // //                   <div style={S.grid2}>
// // //                     <div>
// // //                       <Label>Base Price / Night (₹) *</Label>
// // //                       <Input type="number" min="0" value={form.basePrice} onChange={v => f("basePrice", v)} placeholder="e.g., 2500" required />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Monthly Price (₹)</Label>
// // //                       <Input type="number" min="0" value={form.monthlyPrice} onChange={v => f("monthlyPrice", v)} placeholder="e.g., 35000" />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Weekend Price (₹)</Label>
// // //                       <Input type="number" min="0" value={form.weekendPrice} onChange={v => f("weekendPrice", v)} placeholder="e.g., 3000" />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Extra Guest Price (₹)</Label>
// // //                       <Input type="number" min="0" value={form.extraGuestPrice} onChange={v => f("extraGuestPrice", v)} placeholder="e.g., 400" />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Cleaning Fee (₹)</Label>
// // //                       <Input type="number" min="0" value={form.cleaningFee} onChange={v => f("cleaningFee", v)} placeholder="e.g., 250" />
// // //                     </div>
// // //                     <div>
// // //                       <Label>Security Deposit (₹)</Label>
// // //                       <Input type="number" min="0" value={form.securityDeposit} onChange={v => f("securityDeposit", v)} placeholder="e.g., 10000" />
// // //                     </div>
// // //                     {form.basePrice && (
// // //                       <div style={{ gridColumn: "1/-1", background: "#e0f2fe", borderRadius: 10, padding: 16, border: "1px solid #bae6fd" }}>
// // //                         <p style={{ fontSize: 13, fontWeight: 600, color: "#0369a1", marginBottom: 8 }}>Pricing Summary</p>
// // //                         <div style={{ fontSize: 13, color: "#374151", display: "flex", flexDirection: "column", gap: 4 }}>
// // //                           <span>Nightly: ₹{Number(form.basePrice).toLocaleString("en-IN")}/night</span>
// // //                           {form.monthlyPrice && <span>Monthly: ₹{Number(form.monthlyPrice).toLocaleString("en-IN")}/month</span>}
// // //                           {form.weekendPrice && <span>Weekend: ₹{Number(form.weekendPrice).toLocaleString("en-IN")}/night</span>}
// // //                           {form.securityDeposit && <span>Security Deposit: ₹{Number(form.securityDeposit).toLocaleString("en-IN")}</span>}
// // //                         </div>
// // //                       </div>
// // //                     )}
// // //                   </div>
// // //                 )}

// // //                 {/* ── RULES ── */}
// // //                 {activeTab === "rules" && (
// // //                   <div>
// // //                     <p style={{ color: "#6b7280", fontSize: 14, marginBottom: 20 }}>Define house rules for your guests</p>
// // //                     <div style={S.grid2}>
// // //                       {Object.keys(rules).map(k => (
// // //                         <label key={k} style={{ ...S.checkLabel, background: rules[k] ? "#e0f2fe" : "#f9fafb", padding: "12px 16px", borderRadius: 10, border: `1px solid ${rules[k] ? "#bae6fd" : "#e5e7eb"}`, cursor: "pointer" }}>
// // //                           <input type="checkbox" checked={rules[k]} onChange={() => toggleRule(k)} style={{ width: 16, height: 16, accentColor: "#0369a1" }} />
// // //                           <span style={{ fontWeight: 500 }}>{RULE_LABELS[k]}</span>
// // //                           <span style={{ marginLeft: "auto", fontSize: 12, color: rules[k] ? "#0369a1" : "#9ca3af", fontWeight: 600 }}>{rules[k] ? "✓ Allowed" : "✗ Not Allowed"}</span>
// // //                         </label>
// // //                       ))}
// // //                     </div>
// // //                   </div>
// // //                 )}

// // //                 {/* ── MEDIA ── */}
// // //                 {activeTab === "media" && (
// // //                   <div>
// // //                     <p style={{ color: "#6b7280", fontSize: 14, marginBottom: 16 }}>Upload apartment photos. First image will be the main display image. Max 10 images, 5MB each.</p>
// // //                     <div style={S.imgGrid}>
// // //                       {previews.map((src, i) => (
// // //                         <div key={i} style={S.previewItem}>
// // //                           <img src={typeof src === "string" ? src : URL.createObjectURL(src)} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 8 }} onError={e => e.target.style.display = "none"} />
// // //                           {i < images.length && (
// // //                             <button type="button" onClick={() => removeImage(i)} style={S.removeImg}>✕</button>
// // //                           )}
// // //                           {i === 0 && <span style={S.mainBadge}>Main</span>}
// // //                         </div>
// // //                       ))}
// // //                       {previews.length < 10 && (
// // //                         <label style={S.uploadZone}>
// // //                           <span style={{ fontSize: 32, display: "block" }}>+</span>
// // //                           <span style={{ fontSize: 13, color: "#9ca3af" }}>Add Photos</span>
// // //                           <input type="file" multiple accept="image/*" hidden onChange={handleImages} />
// // //                         </label>
// // //                       )}
// // //                     </div>
// // //                     <p style={{ fontSize: 12, color: "#9ca3af", marginTop: 12 }}>{previews.length}/10 images uploaded</p>
// // //                   </div>
// // //                 )}
// // //               </div>

// // //               {/* Footer */}
// // //               <div style={S.modalFoot}>
// // //                 <div style={{ display: "flex", gap: 8 }}>
// // //                   {tabs.findIndex(t => t.id === activeTab) > 0 && (
// // //                     <button type="button" onClick={() => setActiveTab(tabs[tabs.findIndex(t => t.id === activeTab) - 1].id)} style={S.cancelBtn}>← Back</button>
// // //                   )}
// // //                   {tabs.findIndex(t => t.id === activeTab) < tabs.length - 1 && (
// // //                     <button type="button" onClick={() => setActiveTab(tabs[tabs.findIndex(t => t.id === activeTab) + 1].id)} style={S.nextBtn}>Next →</button>
// // //                   )}
// // //                 </div>
// // //                 <div style={{ display: "flex", gap: 8 }}>
// // //                   <button type="button" onClick={closeModal} style={S.cancelBtn}>Cancel</button>
// // //                   <button type="submit" className="ap-submit" style={S.submitBtn} disabled={submitting}>
// // //                     {submitting ? "⏳ Saving..." : editId ? "💾 Update Apartment" : "✓ Add Apartment"}
// // //                   </button>
// // //                 </div>
// // //               </div>
// // //             </form>
// // //           </div>
// // //         </div>
// // //       )}
// // //     </div>
// // //   );
// // // }

// // // /* ── Sub-components ── */
// // // const Label = ({ children }) => <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 6 }}>{children}</label>;
// // // const Input = ({ onChange, ...props }) => <input {...props} onChange={e => onChange(e.target.value)} style={S.input} />;
// // // const Select = ({ value, onChange, options }) => (
// // //   <select value={value} onChange={e => onChange(e.target.value)} style={S.input}>
// // //     {options.map(o => <option key={o} value={o}>{o}</option>)}
// // //   </select>
// // // );

// // // /* ── Styles ── */
// // // const S = {
// // //   page: { maxWidth: 1400, margin: "0 auto", padding: "32px 24px", fontFamily: "'Outfit', sans-serif", background: "#f0f9ff", minHeight: "100vh" },
// // //   header: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 28, flexWrap: "wrap", gap: 16 },
// // //   title: { fontFamily: "'Syne', sans-serif", fontSize: 32, fontWeight: 800, color: "#0c4a6e" },
// // //   subtitle: { fontSize: 14, color: "#7ea8c4", marginTop: 6 },
// // //   addBtn: { padding: "12px 24px", background: "#0369a1", color: "white", border: "none", borderRadius: 10, fontSize: 15, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" },
// // //   toast: c => ({ position: "fixed", top: 20, right: 20, zIndex: 9999, padding: "14px 20px", background: c === "blue" ? "#0369a1" : "#dc2626", color: "white", borderRadius: 10, fontSize: 14, fontWeight: 500, boxShadow: "0 4px 20px rgba(0,0,0,.15)", display: "flex", alignItems: "center", gap: 8 }),
// // //   filterBar: { display: "flex", alignItems: "center", gap: 12, marginBottom: 20, flexWrap: "wrap" },
// // //   searchInput: { flex: 1, minWidth: 220, padding: "10px 16px", border: "1.5px solid #bae6fd", borderRadius: 8, fontSize: 14, fontFamily: "inherit", background: "white" },
// // //   filterSelect: { padding: "10px 16px", border: "1.5px solid #bae6fd", borderRadius: 8, fontSize: 14, fontFamily: "inherit", background: "white" },
// // //   clearBtn: { padding: "10px 16px", background: "#e0f2fe", border: "1.5px solid #bae6fd", borderRadius: 8, fontSize: 14, cursor: "pointer", fontFamily: "inherit", color: "#0369a1" },
// // //   filterCount: { fontSize: 13, color: "#7ea8c4", whiteSpace: "nowrap" },
// // //   center: { display: "flex", justifyContent: "center", alignItems: "center", height: 300 },
// // //   spinner: { width: 40, height: 40, border: "3px solid #bae6fd", borderTop: "3px solid #0369a1", borderRadius: "50%", animation: "spin 1s linear infinite" },
// // //   empty: { textAlign: "center", padding: 80, background: "white", borderRadius: 16, boxShadow: "0 1px 4px rgba(0,0,0,.06)" },
// // //   tableWrap: { background: "white", borderRadius: 16, boxShadow: "0 1px 4px rgba(0,0,0,.06)", overflow: "auto" },
// // //   table: { width: "100%", borderCollapse: "collapse" },
// // //   th: { padding: "14px 16px", textAlign: "left", fontSize: 12, fontWeight: 700, color: "#0369a1", textTransform: "uppercase", letterSpacing: .5, borderBottom: "1px solid #e0f2fe" },
// // //   tr: { borderBottom: "1px solid #f0f9ff", transition: "background .15s" },
// // //   td: { padding: "14px 16px", fontSize: 14, color: "#374151", verticalAlign: "middle" },
// // //   imgWrap: { width: 64, height: 52, borderRadius: 8, overflow: "hidden", background: "#e0f2fe", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" },
// // //   thumb: { width: "100%", height: "100%", objectFit: "cover" },
// // //   typeBadge: { fontSize: 12, fontWeight: 600, color: "#0369a1", background: "#e0f2fe", padding: "4px 10px", borderRadius: 20 },
// // //   pill: { fontSize: 11, background: "#f0f9ff", color: "#0369a1", padding: "2px 8px", borderRadius: 4, fontWeight: 500, border: "1px solid #bae6fd" },
// // //   statusBadge: { fontSize: 12, fontWeight: 600, padding: "4px 12px", borderRadius: 20, display: "inline-block" },
// // //   editBtn: { padding: "8px 10px", background: "#e0f2fe", border: "none", borderRadius: 8, cursor: "pointer", fontSize: 15 },
// // //   deleteBtn: { padding: "8px 10px", background: "#fff5f5", border: "none", borderRadius: 8, cursor: "pointer", fontSize: 15 },
// // //   overlay: { position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 20, backdropFilter: "blur(4px)" },
// // //   modal: { background: "white", borderRadius: 20, width: "100%", maxWidth: 900, maxHeight: "92vh", overflow: "auto", boxShadow: "0 25px 80px rgba(0,0,0,.25)", display: "flex", flexDirection: "column" },
// // //   modalHead: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", padding: "24px 32px", borderBottom: "1px solid #e0f2fe", position: "sticky", top: 0, background: "white", zIndex: 10 },
// // //   closeBtn: { background: "#e0f2fe", border: "none", borderRadius: 8, width: 36, height: 36, fontSize: 18, cursor: "pointer", color: "#0369a1", display: "flex", alignItems: "center", justifyContent: "center" },
// // //   tabsRow: { display: "flex", gap: 0, padding: "0 32px", borderBottom: "1px solid #e0f2fe", overflowX: "auto", flexShrink: 0 },
// // //   tabBtn: { padding: "12px 14px", background: "none", border: "none", fontSize: 12, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap", color: "#6b7280", borderBottom: "2px solid transparent", fontFamily: "inherit", borderRadius: 0 },
// // //   formBody: { padding: "24px 32px", flex: 1, overflowY: "auto" },
// // //   grid2: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 },
// // //   grid4: { display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16 },
// // //   input: { width: "100%", padding: "10px 14px", border: "1.5px solid #e5e7eb", borderRadius: 8, fontSize: 14, fontFamily: "inherit", background: "white", transition: "border .2s, box-shadow .2s" },
// // //   checkGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 },
// // //   checkLabel: { display: "flex", alignItems: "center", gap: 10, fontSize: 14, color: "#374151", cursor: "pointer" },
// // //   chip: { padding: "8px 16px", border: "1.5px solid #e5e7eb", borderRadius: 20, background: "white", fontSize: 13, fontWeight: 500, color: "#6b7280", fontFamily: "inherit" },
// // //   imgGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, 110px)", gap: 12 },
// // //   previewItem: { width: 110, height: 90, borderRadius: 8, overflow: "visible", position: "relative" },
// // //   removeImg: { position: "absolute", top: -8, right: -8, background: "#dc2626", color: "white", border: "none", borderRadius: "50%", width: 22, height: 22, fontSize: 12, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" },
// // //   mainBadge: { position: "absolute", bottom: -8, left: 4, background: "#0369a1", color: "white", fontSize: 10, fontWeight: 700, padding: "2px 6px", borderRadius: 4 },
// // //   uploadZone: { width: 110, height: 90, border: "2px dashed #bae6fd", borderRadius: 8, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#9ca3af", gap: 4 },
// // //   modalFoot: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 32px", borderTop: "1px solid #e0f2fe", position: "sticky", bottom: 0, background: "white" },
// // //   cancelBtn: { padding: "10px 20px", background: "#f3f4f6", border: "none", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit", color: "#374151" },
// // //   nextBtn: { padding: "10px 20px", background: "#e0f2fe", border: "1px solid #bae6fd", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit", color: "#0369a1" },
// // //   submitBtn: { padding: "10px 24px", background: "#0369a1", color: "white", border: "none", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit", transition: "background .2s" },
// // // };




// // import React, { useEffect, useState } from "react";
// // import axios from "axios";

// // const API = "https://bmtvendorvendorfinal.onrender.com/api/vendor/apartment";

// // const AMENITIES = ["WiFi", "AC", "TV", "Parking", "Lift", "Geyser", "Power Backup", "Security", "CCTV", "Intercom", "Gym", "Swimming Pool", "Garden", "Club House", "Play Area", "Visitor Parking"];
// // const APARTMENT_TYPES = ["Studio", "1BHK", "2BHK", "3BHK", "4BHK", "Penthouse"];
// // const FURNISHING_TYPES = ["Fully Furnished", "Semi Furnished", "Unfurnished"];
// // const ROOM_TYPES = ["Entire Apartment", "Private Room", "Shared Room"];
// // const MEAL_PLANS = ["Room Only", "Breakfast", "Breakfast and Dinner", "All Meals", "Custom"];
// // const CANCELLATION = ["Flexible", "Moderate", "Strict", "Non-Refundable"];

// // const DEFAULT_RULES = { smoking: false, alcohol: false, parties: false, loudMusic: false, unmarriedCouples: false, localIdAllowed: false };
// // const RULE_LABELS = { smoking: "Smoking", alcohol: "Alcohol", parties: "Parties", loudMusic: "Loud Music", unmarriedCouples: "Unmarried Couples", localIdAllowed: "Local ID Accepted" };

// // const DEFAULT_FORM = {
// //   apartmentName: "", propertyType: "Apartment", description: "", hostName: "",
// //   phone: "", altPhone: "", email: "",
// //   country: "India", state: "", city: "", area: "", address: "", pincode: "", landmark: "",
// //   lat: "", lng: "",
// //   buildingName: "", towerName: "", floorNumber: "", totalFloors: "", flatNumber: "", societyName: "",
// //   apartmentType: "1BHK", furnishing: "Fully Furnished",
// //   carpetArea: "", superArea: "",
// //   bedrooms: "", hall: "", kitchen: "", bathrooms: "", balcony: "",
// //   maxGuests: "", beds: "",
// //   extraMattressAllowed: false, childrenAllowed: false, petsAllowed: false,
// //   kitchenAvailable: false, selfCookingAllowed: false, vegFoodAvailable: false, nonVegAllowed: false,
// //   basePrice: "", monthlyPrice: "", weekendPrice: "", extraGuestPrice: "", cleaningFee: "", securityDeposit: "",
// //   checkInTime: "14:00", checkOutTime: "11:00",
// //   availableFrom: "", availableTo: "",
// //   roomType: "Entire Apartment", mealPlan: "Room Only", cancellationPolicy: "Moderate", notes: "",
// // };

// // export default function VendorApartment() {
// //   const token = localStorage.getItem("token");
// //   const authHeaders = { headers: { Authorization: `Bearer ${token}` } };

// //   const [apartments, setApartments] = useState([]);
// //   const [filtered, setFiltered] = useState([]);
// //   const [form, setForm] = useState(DEFAULT_FORM);
// //   const [rules, setRules] = useState(DEFAULT_RULES);
// //   const [amenities, setAmenities] = useState([]);
// //   const [images, setImages] = useState([]);
// //   const [previews, setPreviews] = useState([]);
// //   const [editId, setEditId] = useState(null);
// //   const [showModal, setShowModal] = useState(false);
// //   const [activeTab, setActiveTab] = useState("basic");
// //   const [loading, setLoading] = useState(false);
// //   const [submitting, setSubmitting] = useState(false);
// //   const [error, setError] = useState("");
// //   const [success, setSuccess] = useState("");
// //   const [search, setSearch] = useState("");
// //   const [filterStatus, setFilterStatus] = useState("");
// //   const [deleteConfirm, setDeleteConfirm] = useState(null);

// //   useEffect(() => { if (!token) window.location.href = "/"; else fetchApartments(); }, []);
// //   useEffect(() => { applyFilters(); }, [apartments, search, filterStatus]);

// //   const applyFilters = () => {
// //     let res = [...apartments];
// //     if (search) res = res.filter(a => a.apartmentName?.toLowerCase().includes(search.toLowerCase()) || a.city?.toLowerCase().includes(search.toLowerCase()));
// //     if (filterStatus) res = res.filter(a => a.status === filterStatus);
// //     setFiltered(res);
// //   };

// //   const fetchApartments = async () => {
// //     setLoading(true);
// //     try {
// //       const res = await axios.get(API, authHeaders);
// //       setApartments(res.data.data || []);
// //     } catch (e) { setError("Failed to load apartments"); }
// //     setLoading(false);
// //   };

// //   const f = (k, v) => setForm(p => ({ ...p, [k]: v }));
// //   const toggleAmenity = a => setAmenities(p => p.includes(a) ? p.filter(x => x !== a) : [...p, a]);
// //   const toggleRule = k => setRules(p => ({ ...p, [k]: !p[k] }));

// //   const handleImages = e => {
// //     const files = Array.from(e.target.files);
// //     const valid = files.filter(f => f.type.startsWith("image/") && f.size <= 5 * 1024 * 1024);
// //     if (images.length + valid.length > 10) { setError("Max 10 images"); return; }
// //     setImages(p => [...p, ...valid]);
// //     setPreviews(p => [...p, ...valid.map(f => URL.createObjectURL(f))]);
// //   };

// //   const removeImage = i => {
// //     setImages(p => p.filter((_, idx) => idx !== i));
// //     setPreviews(p => p.filter((_, idx) => idx !== i));
// //   };

// //   const handleSubmit = async e => {
// //     e.preventDefault();
// //     if (!form.apartmentName || !form.city || !form.basePrice) { setError("Fill all required fields"); return; }
// //     if (!editId && images.length === 0) { setError("Upload at least one image"); return; }
// //     setSubmitting(true); setError("");

// //     const data = new FormData();
// //     Object.entries(form).forEach(([k, v]) => data.append(k, v));
// //     data.append("amenities", JSON.stringify(amenities));
// //     data.append("houseRules", JSON.stringify(rules));
// //     images.forEach(img => data.append("images", img));

// //     const cfg = { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } };
// //     try {
// //       if (editId) await axios.put(`${API}/${editId}`, data, cfg);
// //       else await axios.post(API, data, cfg);
// //       setSuccess(editId ? "Apartment updated!" : "Apartment added successfully!");
// //       closeModal();
// //       await fetchApartments();
// //       setTimeout(() => setSuccess(""), 3000);
// //     } catch (e) { setError(e.response?.data?.message || "Operation failed"); }
// //     setSubmitting(false);
// //   };

// //   const startEdit = a => {
// //     setEditId(a._id);
// //     setForm({
// //       apartmentName: a.apartmentName || "", propertyType: a.propertyType || "Apartment",
// //       description: a.description || "", hostName: a.hostName || "",
// //       phone: a.phone || "", altPhone: a.altPhone || "", email: a.email || "",
// //       country: a.country || "India", state: a.state || "", city: a.city || "",
// //       area: a.area || "", address: a.address || "", pincode: a.pincode || "", landmark: a.landmark || "",
// //       lat: a.mapLocation?.lat || "", lng: a.mapLocation?.lng || "",
// //       buildingName: a.buildingName || "", towerName: a.towerName || "",
// //       floorNumber: a.floorNumber || "", totalFloors: a.totalFloors || "",
// //       flatNumber: a.flatNumber || "", societyName: a.societyName || "",
// //       apartmentType: a.apartmentType || "1BHK", furnishing: a.furnishing || "Fully Furnished",
// //       carpetArea: a.carpetArea || "", superArea: a.superArea || "",
// //       bedrooms: a.bedrooms || "", hall: a.hall || "", kitchen: a.kitchen || "",
// //       bathrooms: a.bathrooms || "", balcony: a.balcony || "",
// //       maxGuests: a.maxGuests || "", beds: a.beds || "",
// //       extraMattressAllowed: a.extraMattressAllowed || false,
// //       childrenAllowed: a.childrenAllowed || false, petsAllowed: a.petsAllowed || false,
// //       kitchenAvailable: a.kitchenAvailable || false, selfCookingAllowed: a.selfCookingAllowed || false,
// //       vegFoodAvailable: a.vegFoodAvailable || false, nonVegAllowed: a.nonVegAllowed || false,
// //       basePrice: a.pricing?.basePrice || "", monthlyPrice: a.pricing?.monthlyPrice || "",
// //       weekendPrice: a.pricing?.weekendPrice || "", extraGuestPrice: a.pricing?.extraGuestPrice || "",
// //       cleaningFee: a.pricing?.cleaningFee || "", securityDeposit: a.pricing?.securityDeposit || "",
// //       checkInTime: a.checkInTime || "14:00", checkOutTime: a.checkOutTime || "11:00",
// //       availableFrom: a.availableFrom?.split("T")[0] || "", availableTo: a.availableTo?.split("T")[0] || "",
// //       roomType: a.roomType || "Entire Apartment", mealPlan: a.mealPlan || "None",
// //       cancellationPolicy: a.cancellationPolicy || "Moderate", notes: a.notes || "",
// //     });
// //     setAmenities(a.amenities || []);
// //     setRules(a.houseRules || DEFAULT_RULES);
// //     setImages([]); setPreviews(a.images || []);
// //     setShowModal(true); setActiveTab("basic");
// //   };

// //   const handleDelete = async id => {
// //     try {
// //       await axios.delete(`${API}/${id}`, authHeaders);
// //       setDeleteConfirm(null); fetchApartments();
// //       setSuccess("Apartment deleted."); setTimeout(() => setSuccess(""), 3000);
// //     } catch (e) { setError("Delete failed"); }
// //   };

// //   const handleToggle = async a => {
// //     try {
// //       await axios.patch(`${API}/${a._id}/toggle`, {}, authHeaders);
// //       fetchApartments();
// //     } catch (e) { setError(e.response?.data?.message || "Toggle failed"); }
// //   };

// //   const closeModal = () => { setShowModal(false); setEditId(null); setForm(DEFAULT_FORM); setRules(DEFAULT_RULES); setAmenities([]); setImages([]); setPreviews([]); setActiveTab("basic"); setError(""); };

// //   const tabs = [
// //     { id: "basic", label: "Basic Info", icon: "🏢" },
// //     { id: "location", label: "Location", icon: "📍" },
// //     { id: "building", label: "Building", icon: "🏗️" },
// //     { id: "details", label: "Details", icon: "📐" },
// //     { id: "amenities", label: "Amenities", icon: "✨" },
// //     { id: "food", label: "Food", icon: "🍽️" },
// //     { id: "pricing", label: "Pricing", icon: "💰" },
// //     { id: "rules", label: "Rules", icon: "📋" },
// //     { id: "media", label: "Photos", icon: "📸" },
// //   ];

// //   const statusColor = s => ({ approved: "#0369a1", pending: "#d97706", rejected: "#dc2626", inactive: "#6b7280" }[s] || "#6b7280");
// //   const statusBg = s => ({ approved: "#e0f2fe", pending: "#fef3c7", rejected: "#fee2e2", inactive: "#f3f4f6" }[s] || "#f3f4f6");

// //   return (
// //     <div style={S.page}>
// //       <style>{`
// //         @import url('https://fonts.googleapis.com/css2?family=Syne:wght@600;700;800&family=Outfit:wght@400;500;600&display=swap');
// //         * { box-sizing: border-box; margin: 0; padding: 0; }
// //         body { font-family: 'Outfit', sans-serif; }
// //         .ap-row:hover { background: #f0f9ff !important; }
// //         @media (max-width: 700px) {
// //           .ap-form-grid { grid-template-columns: 1fr !important; }
// //         }
// //         .ap-tab:hover { background: #e0f2fe !important; }
// //         .ap-tab.active { background: #0369a1 !important; color: white !important; }
// //         .ap-chip { cursor: pointer; transition: all .2s; }
// //         .ap-chip:hover { border-color: #0369a1 !important; color: #0369a1 !important; }
// //         .ap-chip.on { background: #0369a1 !important; color: white !important; border-color: #0369a1 !important; }
// //         input:focus, select:focus, textarea:focus { outline: none; border-color: #0369a1 !important; box-shadow: 0 0 0 3px rgba(3,105,161,0.12) !important; }
// //         .ap-submit:hover { background: #075985 !important; }
// //         .ap-del:hover { background: #fef2f2 !important; }
// //         ::-webkit-scrollbar { width: 6px; } ::-webkit-scrollbar-track { background: #f1f5f9; } ::-webkit-scrollbar-thumb { background: #bae6fd; border-radius: 3px; }
// //       `}</style>

// //       {/* Header */}
// //       <div style={S.header}>
// //         <div>
// //           <h1 style={S.title}>Apartment Listings</h1>
// //           <p style={S.subtitle}>{apartments.length} apartments · Manage your properties</p>
// //         </div>
// //         <button onClick={() => { closeModal(); setShowModal(true); window.scrollTo({ top: 0, behavior: "smooth" }); }} style={S.addBtn}>+ Add Apartment</button>
// //       </div>

// //       {/* Toasts */}
// //       {success && <div style={S.toast("blue")}>{success}</div>}
// //       {error && !showModal && <div style={S.toast("red")}>{error} <button onClick={() => setError("")} style={{ background: "none", border: "none", color: "inherit", cursor: "pointer", marginLeft: 8 }}>✕</button></div>}

// //       {/* Filters */}
// //       <div style={S.filterBar}>
// //         <input placeholder="🔍 Search by name or city..." value={search} onChange={e => setSearch(e.target.value)} style={S.searchInput} />
// //         <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)} style={S.filterSelect}>
// //           <option value="">All Status</option>
// //           <option value="pending">Pending</option>
// //           <option value="approved">Approved</option>
// //           <option value="rejected">Rejected</option>
// //           <option value="inactive">Inactive</option>
// //         </select>
// //         {(search || filterStatus) && <button onClick={() => { setSearch(""); setFilterStatus(""); }} style={S.clearBtn}>Clear</button>}
// //         <span style={S.filterCount}>{filtered.length} of {apartments.length}</span>
// //       </div>

// //       {/* Table */}
// //       {loading ? (
// //         <div style={S.center}><div style={S.spinner} /></div>
// //       ) : filtered.length === 0 ? (
// //         <div style={S.empty}>
// //           <div style={{ fontSize: 64, marginBottom: 16 }}>🏢</div>
// //           <p style={{ fontSize: 20, fontWeight: 600, color: "#374151" }}>No apartments found</p>
// //           <p style={{ color: "#9ca3af", marginTop: 8 }}>Add your first apartment to get started</p>
// //         </div>
// //       ) : (
// //         <div style={S.tableWrap}>
// //           <table style={S.table}>
// //             <thead>
// //               <tr style={{ background: "#f0f9ff" }}>
// //                 {["Apartment", "Location", "Type & Size", "Pricing", "Amenities", "Status", "Actions"].map(h => (
// //                   <th key={h} style={S.th}>{h}</th>
// //                 ))}
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {filtered.map(a => (
// //                 <tr key={a._id} className="ap-row" style={S.tr}>
// //                   <td style={S.td}>
// //                     <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
// //                       <div style={S.imgWrap}>
// //                         {a.images?.[0] ? <img src={a.images[0]} alt="" style={S.thumb} onError={e => e.target.style.display = "none"} /> : <span style={{ fontSize: 28 }}>🏢</span>}
// //                       </div>
// //                       <div>
// //                         <div style={{ fontWeight: 600, fontSize: 14, color: "#111827" }}>{a.apartmentName}</div>
// //                         {a.societyName && <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>{a.societyName}</div>}
// //                         {a.description && <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2, maxWidth: 200 }}>{a.description.substring(0, 55)}{a.description.length > 55 ? "…" : ""}</div>}
// //                       </div>
// //                     </div>
// //                   </td>
// //                   <td style={S.td}>
// //                     <div style={{ fontSize: 13 }}>
// //                       <div style={{ fontWeight: 500 }}>{a.city}{a.state ? `, ${a.state}` : ""}</div>
// //                       {a.area && <div style={{ color: "#9ca3af", fontSize: 12 }}>{a.area}</div>}
// //                       {a.floorNumber && <div style={{ color: "#9ca3af", fontSize: 12 }}>Floor {a.floorNumber}{a.totalFloors ? `/${a.totalFloors}` : ""}</div>}
// //                     </div>
// //                   </td>
// //                   <td style={S.td}>
// //                     <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
// //                       <span style={S.typeBadge}>{a.apartmentType || "Apartment"}</span>
// //                       {a.furnishing && <span style={{ fontSize: 11, color: "#6b7280" }}>{a.furnishing}</span>}
// //                       <span style={{ fontSize: 11, color: "#9ca3af" }}>
// //                         {[a.bedrooms && `${a.bedrooms}BR`, a.bathrooms && `${a.bathrooms}BA`, a.maxGuests && `${a.maxGuests} guests`].filter(Boolean).join(" · ")}
// //                       </span>
// //                     </div>
// //                   </td>
// //                   <td style={S.td}>
// //                     <div style={{ fontWeight: 700, fontSize: 15, color: "#0369a1" }}>₹{a.pricing?.basePrice?.toLocaleString("en-IN") || "—"}</div>
// //                     <div style={{ fontSize: 11, color: "#9ca3af" }}>per night</div>
// //                     {a.pricing?.monthlyPrice && <div style={{ fontSize: 12, color: "#6b7280", marginTop: 2 }}>₹{Number(a.pricing.monthlyPrice).toLocaleString("en-IN")}/mo</div>}
// //                   </td>
// //                   <td style={S.td}>
// //                     <div style={{ display: "flex", flexWrap: "wrap", gap: 4, maxWidth: 160 }}>
// //                       {(a.amenities || []).slice(0, 3).map((am, i) => <span key={i} style={S.pill}>{am}</span>)}
// //                       {(a.amenities?.length || 0) > 3 && <span style={S.pill}>+{a.amenities.length - 3}</span>}
// //                       {!a.amenities?.length && <span style={{ color: "#9ca3af", fontSize: 12 }}>None</span>}
// //                     </div>
// //                   </td>
// //                   <td style={S.td}>
// //                     <span style={{ ...S.statusBadge, background: statusBg(a.status), color: statusColor(a.status) }}>
// //                       {a.status || "pending"}
// //                     </span>
// //                     {(a.status === "approved" || a.status === "inactive") && (
// //                       <button onClick={() => handleToggle(a)} style={{ display: "block", marginTop: 6, fontSize: 11, background: "none", border: "1px solid #d1d5db", borderRadius: 4, padding: "2px 8px", cursor: "pointer", color: "#6b7280" }}>
// //                         {a.status === "approved" ? "Deactivate" : "Activate"}
// //                       </button>
// //                     )}
// //                   </td>
// //                   <td style={S.td}>
// //                     <div style={{ display: "flex", gap: 6 }}>
// //                       <button onClick={() => startEdit(a)} style={S.editBtn} title="Edit">✏️</button>
// //                       <button onClick={() => setDeleteConfirm(a._id)} className="ap-del" style={S.deleteBtn} title="Delete">🗑️</button>
// //                     </div>
// //                   </td>
// //                 </tr>
// //               ))}
// //             </tbody>
// //           </table>
// //         </div>
// //       )}

// //       {/* Delete Confirm */}
// //       {deleteConfirm && (
// //         <div style={S.overlay} onClick={() => setDeleteConfirm(null)}>
// //           <div style={{ ...S.modal, maxWidth: 400, padding: 32, textAlign: "center" }} onClick={e => e.stopPropagation()}>
// //             <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
// //             <h3 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Delete Apartment?</h3>
// //             <p style={{ color: "#6b7280", marginBottom: 24 }}>This action cannot be undone.</p>
// //             <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
// //               <button onClick={() => setDeleteConfirm(null)} style={S.cancelBtn}>Cancel</button>
// //               <button onClick={() => handleDelete(deleteConfirm)} style={{ ...S.addBtn, background: "#dc2626" }}>Delete</button>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {/* MODAL */}
// //       {showModal && (
// //         <section style={S.inlineFormPanel}>
// //             <div style={S.modalHead}>
// //               <div>
// //                 <h2 style={{ fontFamily: "'Syne', sans-serif", fontSize: 24, fontWeight: 800 }}>
// //                   {editId ? "Edit Apartment" : "Add New Apartment"}
// //                 </h2>
// //                 <p style={{ color: "#6b7280", fontSize: 13, marginTop: 4 }}>Fill in all the details carefully</p>
// //               </div>
// //               <button onClick={closeModal} style={S.cancelBtn}>Cancel / Close</button>
// //             </div>

// //             {error && <div style={{ margin: "0 32px", padding: "10px 16px", background: "#fee2e2", color: "#dc2626", borderRadius: 8, fontSize: 14 }}>{error}</div>}

// //             {/* Tabs */}
// //             <div style={S.tabsRow}>
// //               {tabs.map(t => (
// //                 <button key={t.id} className={`ap-tab ${activeTab === t.id ? "active" : ""}`} onClick={() => setActiveTab(t.id)} style={S.tabBtn}>
// //                   {t.icon} {t.label}
// //                 </button>
// //               ))}
// //             </div>

// //             <form onSubmit={handleSubmit}>
// //               <div style={S.formBody}>

// //                 {/* ── BASIC INFO ── */}
// //                 {activeTab === "basic" && (
// //                   <div style={S.grid2}>
// //                     <div style={{ gridColumn: "1/-1" }}>
// //                       <Label>Apartment Name *</Label>
// //                       <Input value={form.apartmentName} onChange={v => f("apartmentName", v)} placeholder="e.g., Skyline 2BHK Apartment" required />
// //                     </div>
// //                     <div>
// //                       <Label>Host Name</Label>
// //                       <Input value={form.hostName} onChange={v => f("hostName", v)} placeholder="Owner / host name" />
// //                     </div>
// //                     <div>
// //                       <Label>Phone</Label>
// //                       <Input value={form.phone} onChange={v => f("phone", v)} placeholder="+91 XXXXX XXXXX" />
// //                     </div>
// //                     <div>
// //                       <Label>Alternate Phone</Label>
// //                       <Input value={form.altPhone} onChange={v => f("altPhone", v)} placeholder="+91 XXXXX XXXXX" />
// //                     </div>
// //                     <div>
// //                       <Label>Email</Label>
// //                       <Input type="email" value={form.email} onChange={v => f("email", v)} placeholder="host@email.com" />
// //                     </div>
// //                     <div style={{ gridColumn: "1/-1" }}>
// //                       <Label>Description</Label>
// //                       <textarea value={form.description} onChange={e => f("description", e.target.value)} placeholder="Describe your apartment — layout, views, neighbourhood, nearby attractions..." style={{ ...S.input, minHeight: 100, resize: "vertical" }} />
// //                     </div>
// //                     <div>
// //                       <Label>Room Type</Label>
// //                       <Select value={form.roomType} onChange={v => f("roomType", v)} options={ROOM_TYPES} />
// //                     </div>
// //                     <div>
// //                       <Label>Meal Plan</Label>
// //                       <Select value={form.mealPlan} onChange={v => f("mealPlan", v)} options={MEAL_PLANS} />
// //                     </div>
// //                     <div>
// //                       <Label>Cancellation Policy</Label>
// //                       <Select value={form.cancellationPolicy} onChange={v => f("cancellationPolicy", v)} options={CANCELLATION} />
// //                     </div>
// //                     <div>
// //                       <Label>Internal Notes</Label>
// //                       <Input value={form.notes} onChange={v => f("notes", v)} placeholder="Notes (optional)" />
// //                     </div>
// //                   </div>
// //                 )}

// //                 {/* ── LOCATION ── */}
// //                 {activeTab === "location" && (
// //                   <div style={S.grid2}>
// //                     <div style={{ gridColumn: "1/-1" }}>
// //                       <Label>Full Address *</Label>
// //                       <Input value={form.address} onChange={v => f("address", v)} placeholder="Flat no, building, street..." required />
// //                     </div>
// //                     <div>
// //                       <Label>City *</Label>
// //                       <Input value={form.city} onChange={v => f("city", v)} placeholder="e.g., Mumbai" required />
// //                     </div>
// //                     <div>
// //                       <Label>Area / Locality</Label>
// //                       <Input value={form.area} onChange={v => f("area", v)} placeholder="e.g., Bandra West" />
// //                     </div>
// //                     <div>
// //                       <Label>State</Label>
// //                       <Input value={form.state} onChange={v => f("state", v)} placeholder="e.g., Maharashtra" />
// //                     </div>
// //                     <div>
// //                       <Label>Pincode</Label>
// //                       <Input value={form.pincode} onChange={v => f("pincode", v)} placeholder="e.g., 400050" />
// //                     </div>
// //                     <div>
// //                       <Label>Country</Label>
// //                       <Input value={form.country} onChange={v => f("country", v)} placeholder="India" />
// //                     </div>
// //                     <div>
// //                       <Label>Landmark</Label>
// //                       <Input value={form.landmark} onChange={v => f("landmark", v)} placeholder="Near XYZ mall" />
// //                     </div>
// //                     <div>
// //                       <Label>Latitude</Label>
// //                       <Input value={form.lat} onChange={v => f("lat", v)} placeholder="e.g., 19.0760" />
// //                     </div>
// //                     <div>
// //                       <Label>Longitude</Label>
// //                       <Input value={form.lng} onChange={v => f("lng", v)} placeholder="e.g., 72.8777" />
// //                     </div>
// //                   </div>
// //                 )}

// //                 {/* ── BUILDING ── */}
// //                 {activeTab === "building" && (
// //                   <div style={S.grid2}>
// //                     <div>
// //                       <Label>Building Name</Label>
// //                       <Input value={form.buildingName} onChange={v => f("buildingName", v)} placeholder="e.g., Oberoi Splendor" />
// //                     </div>
// //                     <div>
// //                       <Label>Society / Complex Name</Label>
// //                       <Input value={form.societyName} onChange={v => f("societyName", v)} placeholder="e.g., Green Park Society" />
// //                     </div>
// //                     <div>
// //                       <Label>Tower Name</Label>
// //                       <Input value={form.towerName} onChange={v => f("towerName", v)} placeholder="e.g., Tower A" />
// //                     </div>
// //                     <div>
// //                       <Label>Flat Number</Label>
// //                       <Input value={form.flatNumber} onChange={v => f("flatNumber", v)} placeholder="e.g., 1204" />
// //                     </div>
// //                     <div>
// //                       <Label>Floor Number</Label>
// //                       <Input type="number" value={form.floorNumber} onChange={v => f("floorNumber", v)} placeholder="e.g., 12" />
// //                     </div>
// //                     <div>
// //                       <Label>Total Floors in Building</Label>
// //                       <Input type="number" value={form.totalFloors} onChange={v => f("totalFloors", v)} placeholder="e.g., 25" />
// //                     </div>
// //                   </div>
// //                 )}

// //                 {/* ── APARTMENT DETAILS ── */}
// //                 {activeTab === "details" && (
// //                   <div>
// //                     <div style={S.grid2}>
// //                       <div>
// //                         <Label>Apartment Type</Label>
// //                         <Select value={form.apartmentType} onChange={v => f("apartmentType", v)} options={APARTMENT_TYPES} />
// //                       </div>
// //                       <div>
// //                         <Label>Furnishing</Label>
// //                         <Select value={form.furnishing} onChange={v => f("furnishing", v)} options={FURNISHING_TYPES} />
// //                       </div>
// //                       <div>
// //                         <Label>Carpet Area (sq ft)</Label>
// //                         <Input value={form.carpetArea} onChange={v => f("carpetArea", v)} placeholder="e.g., 850" />
// //                       </div>
// //                       <div>
// //                         <Label>Super Area (sq ft)</Label>
// //                         <Input value={form.superArea} onChange={v => f("superArea", v)} placeholder="e.g., 1100" />
// //                       </div>
// //                     </div>
// //                     <div style={{ ...S.grid4, marginTop: 20 }}>
// //                       {[["bedrooms", "Bedrooms"], ["hall", "Hall"], ["kitchen", "Kitchen"], ["bathrooms", "Bathrooms"], ["balcony", "Balcony"], ["maxGuests", "Max Guests"], ["beds", "Beds"]].map(([k, l]) => (
// //                         <div key={k}>
// //                           <Label>{l}</Label>
// //                           <Input type="number" min="0" value={form[k]} onChange={v => f(k, v)} placeholder="0" />
// //                         </div>
// //                       ))}
// //                     </div>
// //                     <div style={{ marginTop: 24 }}>
// //                       <Label>Availability & Timings</Label>
// //                       <div style={{ ...S.grid2, marginTop: 12 }}>
// //                         {[["availableFrom", "Available From", "date"], ["availableTo", "Available To", "date"], ["checkInTime", "Check-In Time", "time"], ["checkOutTime", "Check-Out Time", "time"]].map(([k, l, t]) => (
// //                           <div key={k}>
// //                             <Label>{l}</Label>
// //                             <Input type={t} value={form[k]} onChange={v => f(k, v)} />
// //                           </div>
// //                         ))}
// //                       </div>
// //                     </div>
// //                     <div style={{ marginTop: 24 }}>
// //                       <Label>Guest Policy</Label>
// //                       <div style={S.checkGrid}>
// //                         {[["extraMattressAllowed", "Extra Mattress Allowed"], ["childrenAllowed", "Children Allowed"], ["petsAllowed", "Pets Allowed"]].map(([k, l]) => (
// //                           <label key={k} style={S.checkLabel}>
// //                             <input type="checkbox" checked={form[k]} onChange={e => f(k, e.target.checked)} style={{ width: 16, height: 16, accentColor: "#0369a1" }} />
// //                             {l}
// //                           </label>
// //                         ))}
// //                       </div>
// //                     </div>
// //                   </div>
// //                 )}

// //                 {/* ── AMENITIES ── */}
// //                 {activeTab === "amenities" && (
// //                   <div>
// //                     <p style={{ color: "#6b7280", fontSize: 14, marginBottom: 16 }}>Select all amenities available in your apartment</p>
// //                     <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
// //                       {AMENITIES.map(a => (
// //                         <button key={a} type="button" className={`ap-chip ${amenities.includes(a) ? "on" : ""}`} onClick={() => toggleAmenity(a)} style={S.chip}>
// //                           {a}
// //                         </button>
// //                       ))}
// //                     </div>
// //                     <p style={{ marginTop: 16, fontSize: 13, color: "#9ca3af" }}>{amenities.length} amenities selected</p>
// //                   </div>
// //                 )}

// //                 {/* ── FOOD ── */}
// //                 {activeTab === "food" && (
// //                   <div>
// //                     <p style={{ color: "#6b7280", fontSize: 14, marginBottom: 20 }}>Configure food and kitchen availability</p>
// //                     <div style={S.checkGrid}>
// //                       {[["kitchenAvailable", "Kitchen Available"], ["selfCookingAllowed", "Self Cooking Allowed"], ["vegFoodAvailable", "Veg Food Available"], ["nonVegAllowed", "Non-Veg Allowed"]].map(([k, l]) => (
// //                         <label key={k} style={S.checkLabel}>
// //                           <input type="checkbox" checked={form[k]} onChange={e => f(k, e.target.checked)} style={{ width: 16, height: 16, accentColor: "#0369a1" }} />
// //                           {l}
// //                         </label>
// //                       ))}
// //                     </div>
// //                   </div>
// //                 )}

// //                 {/* ── PRICING ── */}
// //                 {activeTab === "pricing" && (
// //                   <div style={S.grid2}>
// //                     <div>
// //                       <Label>Base Price / Night (₹) *</Label>
// //                       <Input type="number" min="0" value={form.basePrice} onChange={v => f("basePrice", v)} placeholder="e.g., 2500" required />
// //                     </div>
// //                     <div>
// //                       <Label>Monthly Price (₹)</Label>
// //                       <Input type="number" min="0" value={form.monthlyPrice} onChange={v => f("monthlyPrice", v)} placeholder="e.g., 35000" />
// //                     </div>
// //                     <div>
// //                       <Label>Weekend Price (₹)</Label>
// //                       <Input type="number" min="0" value={form.weekendPrice} onChange={v => f("weekendPrice", v)} placeholder="e.g., 3000" />
// //                     </div>
// //                     <div>
// //                       <Label>Extra Guest Price (₹)</Label>
// //                       <Input type="number" min="0" value={form.extraGuestPrice} onChange={v => f("extraGuestPrice", v)} placeholder="e.g., 400" />
// //                     </div>
// //                     <div>
// //                       <Label>Cleaning Fee (₹)</Label>
// //                       <Input type="number" min="0" value={form.cleaningFee} onChange={v => f("cleaningFee", v)} placeholder="e.g., 250" />
// //                     </div>
// //                     <div>
// //                       <Label>Security Deposit (₹)</Label>
// //                       <Input type="number" min="0" value={form.securityDeposit} onChange={v => f("securityDeposit", v)} placeholder="e.g., 10000" />
// //                     </div>
// //                     {form.basePrice && (
// //                       <div style={{ gridColumn: "1/-1", background: "#e0f2fe", borderRadius: 10, padding: 16, border: "1px solid #bae6fd" }}>
// //                         <p style={{ fontSize: 13, fontWeight: 600, color: "#0369a1", marginBottom: 8 }}>Pricing Summary</p>
// //                         <div style={{ fontSize: 13, color: "#374151", display: "flex", flexDirection: "column", gap: 4 }}>
// //                           <span>Nightly: ₹{Number(form.basePrice).toLocaleString("en-IN")}/night</span>
// //                           {form.monthlyPrice && <span>Monthly: ₹{Number(form.monthlyPrice).toLocaleString("en-IN")}/month</span>}
// //                           {form.weekendPrice && <span>Weekend: ₹{Number(form.weekendPrice).toLocaleString("en-IN")}/night</span>}
// //                           {form.securityDeposit && <span>Security Deposit: ₹{Number(form.securityDeposit).toLocaleString("en-IN")}</span>}
// //                         </div>
// //                       </div>
// //                     )}
// //                   </div>
// //                 )}

// //                 {/* ── RULES ── */}
// //                 {activeTab === "rules" && (
// //                   <div>
// //                     <p style={{ color: "#6b7280", fontSize: 14, marginBottom: 20 }}>Define house rules for your guests</p>
// //                     <div style={S.grid2}>
// //                       {Object.keys(rules).map(k => (
// //                         <label key={k} style={{ ...S.checkLabel, background: rules[k] ? "#e0f2fe" : "#f9fafb", padding: "12px 16px", borderRadius: 10, border: `1px solid ${rules[k] ? "#bae6fd" : "#e5e7eb"}`, cursor: "pointer" }}>
// //                           <input type="checkbox" checked={rules[k]} onChange={() => toggleRule(k)} style={{ width: 16, height: 16, accentColor: "#0369a1" }} />
// //                           <span style={{ fontWeight: 500 }}>{RULE_LABELS[k]}</span>
// //                           <span style={{ marginLeft: "auto", fontSize: 12, color: rules[k] ? "#0369a1" : "#9ca3af", fontWeight: 600 }}>{rules[k] ? "✓ Allowed" : "✗ Not Allowed"}</span>
// //                         </label>
// //                       ))}
// //                     </div>
// //                   </div>
// //                 )}

// //                 {/* ── MEDIA ── */}
// //                 {activeTab === "media" && (
// //                   <div>
// //                     <p style={{ color: "#6b7280", fontSize: 14, marginBottom: 16 }}>Upload apartment photos. First image will be the main display image. Max 10 images, 5MB each.</p>
// //                     <div style={S.imgGrid}>
// //                       {previews.map((src, i) => (
// //                         <div key={i} style={S.previewItem}>
// //                           <img src={typeof src === "string" ? src : URL.createObjectURL(src)} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 8 }} onError={e => e.target.style.display = "none"} />
// //                           {i < images.length && (
// //                             <button type="button" onClick={() => removeImage(i)} style={S.removeImg}>✕</button>
// //                           )}
// //                           {i === 0 && <span style={S.mainBadge}>Main</span>}
// //                         </div>
// //                       ))}
// //                       {previews.length < 10 && (
// //                         <label style={S.uploadZone}>
// //                           <span style={{ fontSize: 32, display: "block" }}>+</span>
// //                           <span style={{ fontSize: 13, color: "#9ca3af" }}>Add Photos</span>
// //                           <input type="file" multiple accept="image/*" hidden onChange={handleImages} />
// //                         </label>
// //                       )}
// //                     </div>
// //                     <p style={{ fontSize: 12, color: "#9ca3af", marginTop: 12 }}>{previews.length}/10 images uploaded</p>
// //                   </div>
// //                 )}
// //               </div>

// //               {/* Footer */}
// //               <div style={S.modalFoot}>
// //                 <div style={{ display: "flex", gap: 8 }}>
// //                   {tabs.findIndex(t => t.id === activeTab) > 0 && (
// //                     <button type="button" onClick={() => setActiveTab(tabs[tabs.findIndex(t => t.id === activeTab) - 1].id)} style={S.cancelBtn}>← Back</button>
// //                   )}
// //                   {tabs.findIndex(t => t.id === activeTab) < tabs.length - 1 && (
// //                     <button type="button" onClick={() => setActiveTab(tabs[tabs.findIndex(t => t.id === activeTab) + 1].id)} style={S.nextBtn}>Next →</button>
// //                   )}
// //                 </div>
// //                 <div style={{ display: "flex", gap: 8 }}>
// //                   <button type="button" onClick={closeModal} style={S.cancelBtn}>Cancel</button>
// //                   <button type="submit" className="ap-submit" style={S.submitBtn} disabled={submitting}>
// //                     {submitting ? "⏳ Saving..." : editId ? "💾 Update Apartment" : "✓ Add Apartment"}
// //                   </button>
// //                 </div>
// //               </div>
// //             </form>
// //         </section>
// //       )}
// //     </div>
// //   );
// // }

// // /* ── Sub-components ── */
// // const Label = ({ children }) => <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#374151", marginBottom: 6 }}>{children}</label>;
// // const Input = ({ onChange, ...props }) => <input {...props} onChange={e => onChange(e.target.value)} style={S.input} />;
// // const Select = ({ value, onChange, options }) => (
// //   <select value={value} onChange={e => onChange(e.target.value)} style={S.input}>
// //     {options.map(o => <option key={o} value={o}>{o}</option>)}
// //   </select>
// // );

// // /* ── Styles ── */
// // const S = {
// //   page: { maxWidth: 1400, margin: "0 auto", padding: "32px 24px", fontFamily: "'Outfit', sans-serif", background: "#f5faff", minHeight: "100vh", color: "#0f172a" },
// //   inlineFormPanel: { background: "#ffffff", border: "1px solid #dbeafe", borderRadius: 18, boxShadow: "0 12px 35px rgba(30,64,175,.08)", overflow: "hidden", marginBottom: 28 },
// //   header: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 28, flexWrap: "wrap", gap: 16 },
// //   title: { fontFamily: "'Syne', sans-serif", fontSize: 32, fontWeight: 800, color: "#0c4a6e" },
// //   subtitle: { fontSize: 14, color: "#7ea8c4", marginTop: 6 },
// //   addBtn: { padding: "12px 24px", background: "#0369a1", color: "white", border: "none", borderRadius: 10, fontSize: 15, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" },
// //   toast: c => ({ position: "fixed", top: 20, right: 20, zIndex: 9999, padding: "14px 20px", background: c === "blue" ? "#0369a1" : "#dc2626", color: "white", borderRadius: 10, fontSize: 14, fontWeight: 500, boxShadow: "0 4px 20px rgba(0,0,0,.15)", display: "flex", alignItems: "center", gap: 8 }),
// //   filterBar: { display: "flex", alignItems: "center", gap: 12, marginBottom: 20, flexWrap: "wrap" },
// //   searchInput: { flex: 1, minWidth: 220, padding: "10px 16px", border: "1.5px solid #bae6fd", borderRadius: 8, fontSize: 14, fontFamily: "inherit", background: "white" },
// //   filterSelect: { padding: "10px 16px", border: "1.5px solid #bae6fd", borderRadius: 8, fontSize: 14, fontFamily: "inherit", background: "white" },
// //   clearBtn: { padding: "10px 16px", background: "#e0f2fe", border: "1.5px solid #bae6fd", borderRadius: 8, fontSize: 14, cursor: "pointer", fontFamily: "inherit", color: "#0369a1" },
// //   filterCount: { fontSize: 13, color: "#7ea8c4", whiteSpace: "nowrap" },
// //   center: { display: "flex", justifyContent: "center", alignItems: "center", height: 300 },
// //   spinner: { width: 40, height: 40, border: "3px solid #bae6fd", borderTop: "3px solid #0369a1", borderRadius: "50%", animation: "spin 1s linear infinite" },
// //   empty: { textAlign: "center", padding: 80, background: "white", borderRadius: 16, boxShadow: "0 1px 4px rgba(0,0,0,.06)" },
// //   tableWrap: { background: "white", borderRadius: 16, boxShadow: "0 1px 4px rgba(0,0,0,.06)", overflow: "auto" },
// //   table: { width: "100%", borderCollapse: "collapse" },
// //   th: { padding: "14px 16px", textAlign: "left", fontSize: 12, fontWeight: 700, color: "#0369a1", textTransform: "uppercase", letterSpacing: .5, borderBottom: "1px solid #e0f2fe" },
// //   tr: { borderBottom: "1px solid #f0f9ff", transition: "background .15s" },
// //   td: { padding: "14px 16px", fontSize: 14, color: "#374151", verticalAlign: "middle" },
// //   imgWrap: { width: 64, height: 52, borderRadius: 8, overflow: "hidden", background: "#e0f2fe", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" },
// //   thumb: { width: "100%", height: "100%", objectFit: "cover" },
// //   typeBadge: { fontSize: 12, fontWeight: 600, color: "#0369a1", background: "#e0f2fe", padding: "4px 10px", borderRadius: 20 },
// //   pill: { fontSize: 11, background: "#f0f9ff", color: "#0369a1", padding: "2px 8px", borderRadius: 4, fontWeight: 500, border: "1px solid #bae6fd" },
// //   statusBadge: { fontSize: 12, fontWeight: 600, padding: "4px 12px", borderRadius: 20, display: "inline-block" },
// //   editBtn: { padding: "8px 10px", background: "#e0f2fe", border: "none", borderRadius: 8, cursor: "pointer", fontSize: 15 },
// //   deleteBtn: { padding: "8px 10px", background: "#fff5f5", border: "none", borderRadius: 8, cursor: "pointer", fontSize: 15 },
// //   overlay: { position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 20, backdropFilter: "blur(4px)" },
// //   modal: { background: "white", borderRadius: 18, width: "100%" },
// //   modalHead: { display: "flex", justifyContent: "space-between", alignItems: "flex-start", padding: "24px 32px", borderBottom: "1px solid #e0f2fe", position: "sticky", top: 0, background: "white", zIndex: 10 },
// //   closeBtn: { background: "#e0f2fe", border: "none", borderRadius: 8, width: 36, height: 36, fontSize: 18, cursor: "pointer", color: "#0369a1", display: "flex", alignItems: "center", justifyContent: "center" },
// //   tabsRow: { display: "flex", gap: 0, padding: "0 32px", borderBottom: "1px solid #e0f2fe", overflowX: "auto", flexShrink: 0 },
// //   tabBtn: { padding: "12px 14px", background: "none", border: "none", fontSize: 12, fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap", color: "#6b7280", borderBottom: "2px solid transparent", fontFamily: "inherit", borderRadius: 0 },
// //   formBody: { padding: "24px 32px" },
// //   grid2: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 },
// //   grid4: { display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16 },
// //   input: { width: "100%", padding: "10px 14px", border: "1.5px solid #e5e7eb", borderRadius: 8, fontSize: 14, fontFamily: "inherit", background: "white", transition: "border .2s, box-shadow .2s" },
// //   checkGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12 },
// //   checkLabel: { display: "flex", alignItems: "center", gap: 10, fontSize: 14, color: "#374151", cursor: "pointer" },
// //   chip: { padding: "8px 16px", border: "1.5px solid #e5e7eb", borderRadius: 20, background: "white", fontSize: 13, fontWeight: 500, color: "#6b7280", fontFamily: "inherit" },
// //   imgGrid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, 110px)", gap: 12 },
// //   previewItem: { width: 110, height: 90, borderRadius: 8, overflow: "visible", position: "relative" },
// //   removeImg: { position: "absolute", top: -8, right: -8, background: "#dc2626", color: "white", border: "none", borderRadius: "50%", width: 22, height: 22, fontSize: 12, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" },
// //   mainBadge: { position: "absolute", bottom: -8, left: 4, background: "#0369a1", color: "white", fontSize: 10, fontWeight: 700, padding: "2px 6px", borderRadius: 4 },
// //   uploadZone: { width: 110, height: 90, border: "2px dashed #bae6fd", borderRadius: 8, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#9ca3af", gap: 4 },
// //   modalFoot: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 32px", borderTop: "1px solid #e0f2fe", background: "white", flexWrap: "wrap", gap: 12 },
// //   cancelBtn: { padding: "10px 20px", background: "#f3f4f6", border: "none", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit", color: "#374151" },
// //   nextBtn: { padding: "10px 20px", background: "#e0f2fe", border: "1px solid #bae6fd", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit", color: "#0369a1" },
// //   submitBtn: { padding: "10px 24px", background: "#0369a1", color: "white", border: "none", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit", transition: "background .2s" },
// // };



// import { useCallback, useEffect, useMemo, useRef, useState } from "react";
// import axios from "axios";

// /* ==============================
//    CONFIG
// ============================== */
// const BASE =
//   (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_URL) ||
//   "https://bmtvendorvendorfinal.onrender.com";
// const API = `${BASE}/api/vendor/apartment`;

// const AMENITIES = ["WiFi", "AC", "TV", "Parking", "Lift", "Geyser", "Power Backup", "Security", "CCTV", "Intercom", "Gym", "Swimming Pool", "Garden", "Club House", "Play Area", "Visitor Parking"];
// const APARTMENT_TYPES = ["Studio", "1BHK", "2BHK", "3BHK", "4BHK", "Penthouse"];
// const FURNISHING_TYPES = ["Fully Furnished", "Semi Furnished", "Unfurnished"];
// const ROOM_TYPES = ["Entire Apartment", "Private Room", "Shared Room"];
// const MEAL_PLANS = ["Room Only", "Breakfast", "Breakfast and Dinner", "All Meals", "Custom"];
// const CANCELLATION = ["Flexible", "Moderate", "Strict", "Non-Refundable"];

// const DEFAULT_RULES = { smoking: false, alcohol: false, parties: false, loudMusic: false, unmarriedCouples: false, localIdAllowed: false };
// const RULE_LABELS = { smoking: "Smoking", alcohol: "Alcohol", parties: "Parties", loudMusic: "Loud music", unmarriedCouples: "Unmarried couples", localIdAllowed: "Local ID accepted" };

// const DEFAULT_FORM = {
//   apartmentName: "", propertyType: "Apartment", description: "", hostName: "",
//   phone: "", altPhone: "", email: "",
//   country: "India", state: "", city: "", area: "", address: "", pincode: "", landmark: "",
//   lat: "", lng: "",
//   buildingName: "", towerName: "", floorNumber: "", totalFloors: "", flatNumber: "", societyName: "",
//   apartmentType: "1BHK", furnishing: "Fully Furnished",
//   carpetArea: "", superArea: "",
//   bedrooms: "", hall: "", kitchen: "", bathrooms: "", balcony: "",
//   maxGuests: "", beds: "",
//   extraMattressAllowed: false, childrenAllowed: false, petsAllowed: false,
//   kitchenAvailable: false, selfCookingAllowed: false, vegFoodAvailable: false, nonVegAllowed: false,
//   basePrice: "", monthlyPrice: "", weekendPrice: "", extraGuestPrice: "", cleaningFee: "", securityDeposit: "",
//   checkInTime: "14:00", checkOutTime: "11:00",
//   availableFrom: "", availableTo: "",
//   roomType: "Entire Apartment", mealPlan: "Room Only", cancellationPolicy: "Moderate", notes: "",
// };

// /* ==============================
//    FORM FIELD CONFIG (tab wise)
// ============================== */
// const F = (k, l, t = "text", x = {}) => ({ k, l, t, ...x });
// const H = (h) => ({ h });

// const TABS = [
//   { id: "basic", label: "Basic info" },
//   { id: "location", label: "Location" },
//   { id: "building", label: "Building" },
//   { id: "details", label: "Details" },
//   { id: "amenities", label: "Amenities" },
//   { id: "food", label: "Food" },
//   { id: "pricing", label: "Pricing" },
//   { id: "rules", label: "House rules" },
//   { id: "media", label: "Photos" },
// ];

// const FIELDS = {
//   basic: [
//     F("apartmentName", "Apartment name *", "text", { full: true, ph: "e.g., Skyline 2BHK Apartment" }),
//     F("hostName", "Host name", "text", { ph: "Owner or host name" }),
//     F("phone", "Phone", "tel", { ph: "+91 XXXXX XXXXX" }),
//     F("altPhone", "Alternate phone", "tel", { ph: "+91 XXXXX XXXXX" }),
//     F("email", "Email", "email", { ph: "host@email.com" }),
//     F("description", "Description", "textarea", { full: true, ph: "Layout, views, neighbourhood, nearby attractions..." }),
//     F("roomType", "Room type", "select", { o: ROOM_TYPES }),
//     F("mealPlan", "Meal plan", "select", { o: MEAL_PLANS }),
//     F("cancellationPolicy", "Cancellation policy", "select", { o: CANCELLATION }),
//     F("notes", "Internal notes", "text", { ph: "Optional" }),
//   ],
//   location: [
//     F("address", "Full address *", "text", { full: true, ph: "Flat no, building, street..." }),
//     F("city", "City *", "text", { ph: "e.g., Mumbai" }),
//     F("area", "Area / locality", "text", { ph: "e.g., Bandra West" }),
//     F("state", "State", "text", { ph: "e.g., Maharashtra" }),
//     F("pincode", "Pincode", "text", { ph: "e.g., 400050" }),
//     F("country", "Country", "text"),
//     F("landmark", "Landmark", "text", { ph: "Near XYZ mall" }),
//     F("lat", "Latitude", "text", { ph: "e.g., 19.0760" }),
//     F("lng", "Longitude", "text", { ph: "e.g., 72.8777" }),
//   ],
//   building: [
//     F("buildingName", "Building name", "text", { ph: "e.g., Oberoi Splendor" }),
//     F("societyName", "Society / complex", "text", { ph: "e.g., Green Park Society" }),
//     F("towerName", "Tower", "text", { ph: "e.g., Tower A" }),
//     F("flatNumber", "Flat number", "text", { ph: "e.g., 1204" }),
//     F("floorNumber", "Floor number", "number", { ph: "e.g., 12" }),
//     F("totalFloors", "Total floors in building", "number", { ph: "e.g., 25" }),
//   ],
//   details: [
//     F("apartmentType", "Apartment type", "select", { o: APARTMENT_TYPES }),
//     F("furnishing", "Furnishing", "select", { o: FURNISHING_TYPES }),
//     F("carpetArea", "Carpet area (sq ft)", "number", { ph: "e.g., 850" }),
//     F("superArea", "Super area (sq ft)", "number", { ph: "e.g., 1100" }),
//     F("bedrooms", "Bedrooms", "number"),
//     F("hall", "Hall", "number"),
//     F("kitchen", "Kitchen", "number"),
//     F("bathrooms", "Bathrooms", "number"),
//     F("balcony", "Balcony", "number"),
//     F("maxGuests", "Max guests", "number"),
//     F("beds", "Beds", "number"),
//     H("Availability and timings"),
//     F("availableFrom", "Available from", "date"),
//     F("availableTo", "Available to", "date"),
//     F("checkInTime", "Check-in time", "time"),
//     F("checkOutTime", "Check-out time", "time"),
//     H("Guest policy"),
//     F("extraMattressAllowed", "Extra mattress allowed", "checkbox"),
//     F("childrenAllowed", "Children allowed", "checkbox"),
//     F("petsAllowed", "Pets allowed", "checkbox"),
//   ],
//   food: [
//     F("kitchenAvailable", "Kitchen available", "checkbox"),
//     F("selfCookingAllowed", "Self cooking allowed", "checkbox"),
//     F("vegFoodAvailable", "Veg food available", "checkbox"),
//     F("nonVegAllowed", "Non-veg allowed", "checkbox"),
//   ],
//   pricing: [
//     F("basePrice", "Base price per night (INR) *", "number", { ph: "e.g., 2500" }),
//     F("monthlyPrice", "Monthly price (INR)", "number", { ph: "e.g., 35000" }),
//     F("weekendPrice", "Weekend price (INR)", "number", { ph: "e.g., 3000" }),
//     F("extraGuestPrice", "Extra guest price (INR)", "number", { ph: "e.g., 400" }),
//     F("cleaningFee", "Cleaning fee (INR)", "number", { ph: "e.g., 250" }),
//     F("securityDeposit", "Security deposit (INR)", "number", { ph: "e.g., 10000" }),
//   ],
// };

// const NUMERIC_KEYS = ["floorNumber", "totalFloors", "carpetArea", "superArea", "bedrooms", "hall", "kitchen", "bathrooms", "balcony", "maxGuests", "beds", "basePrice", "monthlyPrice", "weekendPrice", "extraGuestPrice", "cleaningFee", "securityDeposit"];

// /* ==============================
//    HELPERS
// ============================== */
// const inr = (n) =>
//   n === undefined || n === null || n === ""
//     ? "-"
//     : new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(Number(n));

// const nv = (x, d = "") => (x === undefined || x === null ? d : x);
// const dateOnly = (v) => (v ? String(v).split("T")[0] : "");
// const yn = (b) => (b ? "Yes" : "No");

// function apartmentToForm(a) {
//   return {
//     apartmentName: nv(a.apartmentName), propertyType: nv(a.propertyType, "Apartment"),
//     description: nv(a.description), hostName: nv(a.hostName),
//     phone: nv(a.phone), altPhone: nv(a.altPhone), email: nv(a.email),
//     country: nv(a.country, "India"), state: nv(a.state), city: nv(a.city),
//     area: nv(a.area), address: nv(a.address), pincode: nv(a.pincode), landmark: nv(a.landmark),
//     lat: nv(a.mapLocation?.lat), lng: nv(a.mapLocation?.lng),
//     buildingName: nv(a.buildingName), towerName: nv(a.towerName),
//     floorNumber: nv(a.floorNumber), totalFloors: nv(a.totalFloors),
//     flatNumber: nv(a.flatNumber), societyName: nv(a.societyName),
//     apartmentType: nv(a.apartmentType, "1BHK"), furnishing: nv(a.furnishing, "Fully Furnished"),
//     carpetArea: nv(a.carpetArea), superArea: nv(a.superArea),
//     bedrooms: nv(a.bedrooms), hall: nv(a.hall), kitchen: nv(a.kitchen),
//     bathrooms: nv(a.bathrooms), balcony: nv(a.balcony),
//     maxGuests: nv(a.maxGuests), beds: nv(a.beds),
//     extraMattressAllowed: !!a.extraMattressAllowed, childrenAllowed: !!a.childrenAllowed, petsAllowed: !!a.petsAllowed,
//     kitchenAvailable: !!a.kitchenAvailable, selfCookingAllowed: !!a.selfCookingAllowed,
//     vegFoodAvailable: !!a.vegFoodAvailable, nonVegAllowed: !!a.nonVegAllowed,
//     basePrice: nv(a.pricing?.basePrice), monthlyPrice: nv(a.pricing?.monthlyPrice),
//     weekendPrice: nv(a.pricing?.weekendPrice), extraGuestPrice: nv(a.pricing?.extraGuestPrice),
//     cleaningFee: nv(a.pricing?.cleaningFee), securityDeposit: nv(a.pricing?.securityDeposit),
//     checkInTime: nv(a.checkInTime, "14:00"), checkOutTime: nv(a.checkOutTime, "11:00"),
//     availableFrom: dateOnly(a.availableFrom), availableTo: dateOnly(a.availableTo),
//     roomType: nv(a.roomType, "Entire Apartment"), mealPlan: nv(a.mealPlan, "Room Only"),
//     cancellationPolicy: nv(a.cancellationPolicy, "Moderate"), notes: nv(a.notes),
//   };
// }

// function validate(form, hasImages) {
//   if (!form.apartmentName.trim()) return { tab: "basic", msg: "Apartment name is required." };
//   if (form.email && !/^\S+@\S+\.\S+$/.test(form.email)) return { tab: "basic", msg: "Enter a valid email address." };
//   if (!form.address.trim()) return { tab: "location", msg: "Full address is required." };
//   if (!form.city.trim()) return { tab: "location", msg: "City is required." };
//   if (form.availableFrom && form.availableTo && form.availableFrom > form.availableTo)
//     return { tab: "details", msg: "Available-from date must be before available-to date." };
//   if (form.basePrice === "" || Number(form.basePrice) <= 0) return { tab: "pricing", msg: "Base price per night is required." };
//   for (const k of NUMERIC_KEYS) {
//     if (form[k] !== "" && Number(form[k]) < 0) {
//       const tab = Object.entries(FIELDS).find(([, list]) => list.some((x) => x.k === k))?.[0] || "basic";
//       return { tab, msg: "Numbers cannot be negative." };
//     }
//   }
//   if (!hasImages) return { tab: "media", msg: "Upload at least one photo." };
//   return null;
// }

// const statusLabel = (s) => ({ approved: "Approved", pending: "Pending", rejected: "Rejected", inactive: "Inactive" }[s] || "Pending");

// /* ==============================
//    MAIN COMPONENT
// ============================== */
// export default function VendorApartment() {
//  const token = localStorage.getItem("vendorToken") || localStorage.getItem("token");
//   const authHeaders = useMemo(() => ({ headers: { Authorization: `Bearer ${token}` } }), [token]);

//   const [apartments, setApartments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [pageError, setPageError] = useState("");
//   const [toast, setToast] = useState(null); // {type, msg}
//   const [search, setSearch] = useState("");
//   const [filterStatus, setFilterStatus] = useState("");

//   // form modal
//   const [formOpen, setFormOpen] = useState(false);
//   const [editId, setEditId] = useState(null);
//   const [form, setForm] = useState(DEFAULT_FORM);
//   const [rules, setRules] = useState(DEFAULT_RULES);
//   const [amenities, setAmenities] = useState([]);
//   const [existingImages, setExistingImages] = useState([]);
//   const [newFiles, setNewFiles] = useState([]); // [{file, url}]
//   const [activeTab, setActiveTab] = useState("basic");
//   const [formError, setFormError] = useState("");
//   const [submitting, setSubmitting] = useState(false);
//   const snapshot = useRef("");

//   // view / delete
//   const [viewItem, setViewItem] = useState(null);
//   const [viewImg, setViewImg] = useState(0);
//   const [deleteItem, setDeleteItem] = useState(null);
//   const [deleting, setDeleting] = useState(false);

//   const showToast = (msg, type = "ok") => {
//     setToast({ msg, type });
//     setTimeout(() => setToast(null), 3200);
//   };

//   /* ---------- load ---------- */
//   // const fetchApartments = useCallback(async () => {
//   //   setPageError("");
//   //   try {
//   //     const res = await axios.get(API, authHeaders);
//   //     setApartments(res.data.data || []);
//   //   } catch (e) {
//   //     setPageError(e.response?.data?.message || "Failed to load apartments.");
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // }, [authHeaders]);
//   const fetchApartments = useCallback(async () => {
//     setPageError("");
//     try {
//       const res = await axios.get(API, authHeaders);
//       setApartments(res.data.data || []);
//     } catch (e) {
//       setPageError(
//         e.response?.status === 401
//           ? "Session expired. Please login again."
//           : e.response?.data?.message || "Failed to load apartments."
//       );
//     } finally {
//       setLoading(false);
//     }
//   }, [authHeaders]);
//   // useEffect(() => {
//   //   if (!token) {
//   //     window.location.href = "/";
//   //     return;
//   //   }
//   //   fetchApartments();
//   // }, [token, fetchApartments]);
//     useEffect(() => {
//     if (!token) {
//       setLoading(false);
//       setPageError("Session not found. Please login again.");
//       return;
//     }
//     fetchApartments();
//   }, [token, fetchApartments]);

//   const filtered = useMemo(() => {
//     const q = search.trim().toLowerCase();
//     return apartments.filter(
//       (a) =>
//         (!q || a.apartmentName?.toLowerCase().includes(q) || a.city?.toLowerCase().includes(q) || a.area?.toLowerCase().includes(q)) &&
//         (!filterStatus || (a.status || "pending") === filterStatus)
//     );
//   }, [apartments, search, filterStatus]);

//   /* ---------- modal plumbing ---------- */
//   const anyModal = !!deleteItem;
//   useEffect(() => {
//     document.body.style.overflow = anyModal ? "hidden" : "";
//     return () => { document.body.style.overflow = ""; };
//   }, [anyModal]);

//   const screenKey = formOpen ? "form" : viewItem ? "view" : "list";
//   useEffect(() => {
//     window.scrollTo({ top: 0 });
//   }, [screenKey]);

//   const isDirty = () =>
//     JSON.stringify({ form, rules, amenities }) !== snapshot.current || newFiles.length > 0;

//   const resetForm = () => {
//     newFiles.forEach((n) => URL.revokeObjectURL(n.url));
//     setFormOpen(false);
//     setEditId(null);
//     setForm(DEFAULT_FORM);
//     setRules(DEFAULT_RULES);
//     setAmenities([]);
//     setExistingImages([]);
//     setNewFiles([]);
//     setActiveTab("basic");
//     setFormError("");
//   };

//   const requestCloseForm = () => {
//     if (submitting) return;
//     if (isDirty() && !window.confirm("Close without saving? Your changes will be lost.")) return;
//     resetForm();
//   };

//   useEffect(() => {
//     const onKey = (e) => {
//       if (e.key !== "Escape") return;
//       if (deleteItem) return !deleting && setDeleteItem(null);
//       if (viewItem) return setViewItem(null);
//       if (formOpen) requestCloseForm();
//     };
//     window.addEventListener("keydown", onKey);
//     return () => window.removeEventListener("keydown", onKey);
//   });

//   const openAdd = () => {
//     resetForm();
//     snapshot.current = JSON.stringify({ form: DEFAULT_FORM, rules: DEFAULT_RULES, amenities: [] });
//     setFormOpen(true);
//   };

//   const openEdit = (a) => {
//     resetForm();
//     const f = apartmentToForm(a);
//     const r = { ...DEFAULT_RULES, ...(a.houseRules || {}) };
//     const am = a.amenities || [];
//     snapshot.current = JSON.stringify({ form: f, rules: r, amenities: am });
//     setEditId(a._id);
//     setForm(f);
//     setRules(r);
//     setAmenities(am);
//     setExistingImages(a.images || []);
//     setViewItem(null);
//     setFormOpen(true);
//   };

//   const setField = (k, v) => setForm((p) => ({ ...p, [k]: v }));
//   const toggleAmenity = (a) => setAmenities((p) => (p.includes(a) ? p.filter((x) => x !== a) : [...p, a]));
//   const toggleRule = (k) => setRules((p) => ({ ...p, [k]: !p[k] }));

//   const handleImages = (e) => {
//     const files = Array.from(e.target.files || []);
//     e.target.value = "";
//     const valid = files.filter((f) => f.type.startsWith("image/") && f.size <= 5 * 1024 * 1024);
//     if (valid.length !== files.length) setFormError("Only image files up to 5 MB are allowed.");
//     if (existingImages.length + newFiles.length + valid.length > 10) {
//       setFormError("You can upload a maximum of 10 photos.");
//       return;
//     }
//     setNewFiles((p) => [...p, ...valid.map((file) => ({ file, url: URL.createObjectURL(file) }))]);
//   };

//   const removeNewFile = (i) =>
//     setNewFiles((p) => {
//       URL.revokeObjectURL(p[i].url);
//       return p.filter((_, idx) => idx !== i);
//     });

//   /* ---------- submit ---------- */
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const problem = validate(form, !!editId || newFiles.length > 0);
//     if (problem) {
//       setActiveTab(problem.tab);
//       setFormError(problem.msg);
//       return;
//     }

//     setSubmitting(true);
//     setFormError("");

//     const data = new FormData();
//     Object.entries(form).forEach(([k, v]) => data.append(k, v));
//     data.append("amenities", JSON.stringify(amenities));
//     data.append("houseRules", JSON.stringify(rules));
//     newFiles.forEach((n) => data.append("images", n.file));

//     const cfg = { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } };
//     try {
//       if (editId) await axios.put(`${API}/${editId}`, data, cfg);
//       else await axios.post(API, data, cfg);
//       showToast(editId ? "Apartment updated." : "Apartment added.");
//       resetForm(); // form band ho jata hai
//       fetchApartments();
//     } catch (err) {
//       setFormError(err.response?.data?.message || "Could not save the apartment. Please try again.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   /* ---------- delete / toggle ---------- */
//   const confirmDelete = async () => {
//     setDeleting(true);
//     try {
//       await axios.delete(`${API}/${deleteItem._id}`, authHeaders);
//       setApartments((p) => p.filter((a) => a._id !== deleteItem._id));
//       setDeleteItem(null);
//       showToast("Apartment deleted.");
//     } catch (err) {
//       showToast(err.response?.data?.message || "Delete failed.", "err");
//     } finally {
//       setDeleting(false);
//     }
//   };

//   const handleToggle = async (a) => {
//     try {
//       await axios.patch(`${API}/${a._id}/toggle`, {}, authHeaders);
//       showToast(a.status === "approved" ? "Apartment deactivated." : "Apartment activated.");
//       fetchApartments();
//     } catch (err) {
//       showToast(err.response?.data?.message || "Status change failed.", "err");
//     }
//   };

//   /* ---------- render helpers ---------- */
//   const renderField = (x, i) => {
//     if (x.h) return <h4 key={`h${i}`} className="va-sub full">{x.h}</h4>;
//     const id = `f-${x.k}`;
//     if (x.t === "checkbox")
//       return (
//         <label key={x.k} className={`va-check ${form[x.k] ? "on" : ""}`}>
//           <input type="checkbox" checked={!!form[x.k]} onChange={(e) => setField(x.k, e.target.checked)} />
//           {x.l}
//         </label>
//       );
//     return (
//       <div key={x.k} className={x.full ? "full" : ""}>
//         <label htmlFor={id} className="va-label">{x.l}</label>
//         {x.t === "select" ? (
//           <select id={id} value={form[x.k]} onChange={(e) => setField(x.k, e.target.value)}>
//             {x.o.map((o) => <option key={o}>{o}</option>)}
//           </select>
//         ) : x.t === "textarea" ? (
//           <textarea id={id} rows={4} value={form[x.k]} placeholder={x.ph} onChange={(e) => setField(x.k, e.target.value)} />
//         ) : (
//           <input
//             id={id}
//             type={x.t}
//             min={x.t === "number" ? 0 : undefined}
//             value={form[x.k]}
//             placeholder={x.ph}
//             onChange={(e) => setField(x.k, e.target.value)}
//           />
//         )}
//       </div>
//     );
//   };

//   const tabIndex = TABS.findIndex((t) => t.id === activeTab);
//   const totalPhotos = existingImages.length + newFiles.length;

//   /* ==============================
//      JSX
//   ============================== */
//   return (
//     <div className="va">
//       <style>{css}</style>

//       {!formOpen && !viewItem && (
//       <>
//       {/* Header */}
//       <header className="va-head">
//         <div>
//           <h1>Apartment listings</h1>
//           <p>{apartments.length} {apartments.length === 1 ? "apartment" : "apartments"} in your account</p>
//         </div>
//         <button className="btn primary" onClick={openAdd}>Add apartment</button>
//       </header>

//       {/* Filters */}
//       <div className="va-filters">
//         <input
//           type="search"
//           placeholder="Search by name, city or area"
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//         />
//         <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
//           <option value="">All statuses</option>
//           <option value="pending">Pending</option>
//           <option value="approved">Approved</option>
//           <option value="rejected">Rejected</option>
//           <option value="inactive">Inactive</option>
//         </select>
//         {(search || filterStatus) && (
//           <button className="btn" onClick={() => { setSearch(""); setFilterStatus(""); }}>Clear</button>
//         )}
//         <span className="va-count">{filtered.length} of {apartments.length}</span>
//       </div>

//       {/* List */}
//       {loading ? (
//         <div className="va-state"><div className="spinner" /></div>
//       ) : pageError ? (
//         <div className="va-state err">
//           <p>{pageError}</p>
//           <button className="btn" onClick={() => { setLoading(true); fetchApartments(); }}>Try again</button>
//         </div>
//       ) : filtered.length === 0 ? (
//         <div className="va-state">
//           <p>{apartments.length === 0 ? "You have not added any apartments yet." : "No apartments match your filters."}</p>
//           {apartments.length === 0 && <button className="btn primary" onClick={openAdd}>Add your first apartment</button>}
//         </div>
//       ) : (
//         <div className="va-table-wrap">
//           <table>
//             <thead>
//               <tr>
//                 <th>Apartment</th>
//                 <th>Location</th>
//                 <th>Type and size</th>
//                 <th>Price</th>
//                 <th>Status</th>
//                 <th className="right">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filtered.map((a) => {
//                 const st = a.status || "pending";
//                 return (
//                   <tr key={a._id}>
//                     <td>
//                       <div className="cell-apt">
//                         <div className="thumb">
//                           {a.images?.[0] ? <img src={a.images[0]} alt="" onError={(e) => (e.target.style.display = "none")} /> : <span>No photo</span>}
//                         </div>
//                         <div>
//                           <button className="name-link" onClick={() => { setViewImg(0); setViewItem(a); }}>{a.apartmentName}</button>
//                           {a.societyName && <small>{a.societyName}</small>}
//                         </div>
//                       </div>
//                     </td>
//                     <td>
//                       {a.city}{a.state ? `, ${a.state}` : ""}
//                       {a.area && <small>{a.area}</small>}
//                     </td>
//                     <td>
//                       <span className="tag">{a.apartmentType || "Apartment"}</span>
//                       <small>
//                         {[a.bedrooms && `${a.bedrooms} bed`, a.bathrooms && `${a.bathrooms} bath`, a.maxGuests && `${a.maxGuests} guests`].filter(Boolean).join(", ") || a.furnishing}
//                       </small>
//                     </td>
//                     <td>
//                       <strong>{inr(a.pricing?.basePrice)}</strong>
//                       <small>per night</small>
//                     </td>
//                     <td>
//                       <span className={`status ${st}`}>{statusLabel(st)}</span>
//                       {(st === "approved" || st === "inactive") && (
//                         <button className="mini" onClick={() => handleToggle(a)}>
//                           {st === "approved" ? "Deactivate" : "Activate"}
//                         </button>
//                       )}
//                     </td>
//                     <td className="right">
//                       <div className="row-actions">
//                         <button className="btn sm" onClick={() => { setViewImg(0); setViewItem(a); }}>View</button>
//                         <button className="btn sm" onClick={() => openEdit(a)}>Edit</button>
//                         <button className="btn sm danger" onClick={() => setDeleteItem(a)}>Delete</button>
//                       </div>
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//       )}

//       </>
//       )}

//       {/* ==============================
//           ADD / EDIT PAGE (full page, not popup)
//       ============================== */}
//       {formOpen && (
//         <div className="page-wrap">
//           <button type="button" className="back" onClick={requestCloseForm}>&larr; Back to apartments</button>
//           <form className="page-card" aria-labelledby="va-form-title" onSubmit={handleSubmit} noValidate>
//             <div className="modal-head">
//               <div>
//                 <h2 id="va-form-title">{editId ? "Edit apartment" : "Add apartment"}</h2>
//                 <p>Step {tabIndex + 1} of {TABS.length}: {TABS[tabIndex].label}</p>
//               </div>
//               <button type="button" className="x" aria-label="Close" onClick={requestCloseForm}>&times;</button>
//             </div>

//             <div className="tabs" role="tablist">
//               {TABS.map((t) => (
//                 <button
//                   key={t.id}
//                   type="button"
//                   role="tab"
//                   aria-selected={activeTab === t.id}
//                   className={`tab ${activeTab === t.id ? "on" : ""}`}
//                   onClick={() => setActiveTab(t.id)}
//                 >
//                   {t.label}
//                 </button>
//               ))}
//             </div>

//             <div className="modal-body">
//               {formError && <div className="form-error" role="alert">{formError}</div>}

//               {FIELDS[activeTab] && (
//                 <div className={activeTab === "food" ? "grid checks" : "grid"}>
//                   {FIELDS[activeTab].map(renderField)}
//                 </div>
//               )}

//               {activeTab === "pricing" && form.basePrice !== "" && (
//                 <div className="summary">
//                   <strong>Pricing summary</strong>
//                   <span>Nightly: {inr(form.basePrice)}</span>
//                   {form.weekendPrice !== "" && <span>Weekend: {inr(form.weekendPrice)} per night</span>}
//                   {form.monthlyPrice !== "" && <span>Monthly: {inr(form.monthlyPrice)}</span>}
//                   {form.securityDeposit !== "" && <span>Security deposit: {inr(form.securityDeposit)}</span>}
//                 </div>
//               )}

//               {activeTab === "amenities" && (
//                 <>
//                   <p className="hint">Select everything guests can use in this apartment.</p>
//                   <div className="chips">
//                     {AMENITIES.map((a) => (
//                       <button
//                         key={a}
//                         type="button"
//                         aria-pressed={amenities.includes(a)}
//                         className={`chip ${amenities.includes(a) ? "on" : ""}`}
//                         onClick={() => toggleAmenity(a)}
//                       >
//                         {a}
//                       </button>
//                     ))}
//                   </div>
//                   <p className="hint">{amenities.length} selected</p>
//                 </>
//               )}

//               {activeTab === "rules" && (
//                 <>
//                   <p className="hint">Mark what guests are allowed to do.</p>
//                   <div className="grid">
//                     {Object.keys(rules).map((k) => (
//                       <label key={k} className={`va-check rule ${rules[k] ? "on" : ""}`}>
//                         <input type="checkbox" checked={rules[k]} onChange={() => toggleRule(k)} />
//                         <span>{RULE_LABELS[k]}</span>
//                         <em>{rules[k] ? "Allowed" : "Not allowed"}</em>
//                       </label>
//                     ))}
//                   </div>
//                 </>
//               )}

//               {activeTab === "media" && (
//                 <>
//                   <p className="hint">The first photo is the cover image. Up to 10 photos, 5 MB each.</p>

//                   {existingImages.length > 0 && (
//                     <>
//                       <h4 className="va-sub">Current photos</h4>
//                       <div className="photos">
//                         {existingImages.map((src, i) => (
//                           <div key={src + i} className="photo">
//                             <img src={src} alt="" onError={(e) => (e.target.style.display = "none")} />
//                             {i === 0 && newFiles.length === 0 && <span className="badge">Cover</span>}
//                           </div>
//                         ))}
//                       </div>
//                     </>
//                   )}

//                   <h4 className="va-sub">{editId ? "New photos" : "Photos"}</h4>
//                   <div className="photos">
//                     {newFiles.map((n, i) => (
//                       <div key={n.url} className="photo">
//                         <img src={n.url} alt="" />
//                         <button type="button" className="rm" aria-label="Remove photo" onClick={() => removeNewFile(i)}>&times;</button>
//                         {i === 0 && !editId && <span className="badge">Cover</span>}
//                       </div>
//                     ))}
//                     {totalPhotos < 10 && (
//                       <label className="photo add">
//                         <span>+</span>
//                         Add photos
//                         <input type="file" multiple accept="image/*" hidden onChange={handleImages} />
//                       </label>
//                     )}
//                   </div>
//                   <p className="hint">{totalPhotos} of 10 photos</p>
//                 </>
//               )}
//             </div>

//             <div className="modal-foot">
//               <div>
//                 {tabIndex > 0 && (
//                   <button type="button" className="btn" onClick={() => setActiveTab(TABS[tabIndex - 1].id)}>Back</button>
//                 )}
//                 {tabIndex < TABS.length - 1 && (
//                   <button type="button" className="btn soft" onClick={() => setActiveTab(TABS[tabIndex + 1].id)}>Next</button>
//                 )}
//               </div>
//               <div>
//                 <button type="button" className="btn" onClick={requestCloseForm} disabled={submitting}>Cancel</button>
//                 <button type="submit" className="btn primary" disabled={submitting}>
//                   {submitting ? "Saving..." : editId ? "Update apartment" : "Add apartment"}
//                 </button>
//               </div>
//             </div>
//           </form>
//         </div>
//       )}

//       {/* ==============================
//           VIEW PAGE (full page, not popup)
//       ============================== */}
//       {viewItem && (
//         <div className="page-wrap">
//           <button type="button" className="back" onClick={() => setViewItem(null)}>&larr; Back to apartments</button>
//           <div className="page-card">
//             <div className="modal-head">
//               <div>
//                 <h2>{viewItem.apartmentName}</h2>
//                 <p>
//                   {[viewItem.area, viewItem.city, viewItem.state].filter(Boolean).join(", ")}
//                 </p>
//               </div>
//               <div className="head-right">
//                 <span className={`status ${viewItem.status || "pending"}`}>{statusLabel(viewItem.status || "pending")}</span>
//                 <button className="x" aria-label="Close" onClick={() => setViewItem(null)}>&times;</button>
//               </div>
//             </div>

//             <div className="modal-body">
//               {viewItem.images?.length > 0 && (
//                 <div className="gallery">
//                   <img className="main" src={viewItem.images[viewImg] || viewItem.images[0]} alt="" />
//                   {viewItem.images.length > 1 && (
//                     <div className="strip">
//                       {viewItem.images.map((src, i) => (
//                         <button key={src + i} className={i === viewImg ? "on" : ""} onClick={() => setViewImg(i)}>
//                           <img src={src} alt="" />
//                         </button>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               )}

//               {viewItem.description && <p className="desc">{viewItem.description}</p>}

//               <div className="view-grid">
//                 <Info title="Host and contact" rows={[
//                   ["Host", viewItem.hostName], ["Phone", viewItem.phone], ["Alternate phone", viewItem.altPhone], ["Email", viewItem.email],
//                 ]} />
//                 <Info title="Address" rows={[
//                   ["Address", viewItem.address], ["Area", viewItem.area], ["City", viewItem.city], ["State", viewItem.state],
//                   ["Pincode", viewItem.pincode], ["Country", viewItem.country], ["Landmark", viewItem.landmark],
//                   ["Map", viewItem.mapLocation?.lat != null && viewItem.mapLocation?.lng != null ? `${viewItem.mapLocation.lat}, ${viewItem.mapLocation.lng}` : ""],
//                 ]} />
//                 <Info title="Building" rows={[
//                   ["Building", viewItem.buildingName], ["Society", viewItem.societyName], ["Tower", viewItem.towerName],
//                   ["Flat number", viewItem.flatNumber],
//                   ["Floor", viewItem.floorNumber !== undefined && viewItem.floorNumber !== "" ? `${viewItem.floorNumber}${viewItem.totalFloors ? ` of ${viewItem.totalFloors}` : ""}` : ""],
//                 ]} />
//                 <Info title="Apartment details" rows={[
//                   ["Type", viewItem.apartmentType], ["Furnishing", viewItem.furnishing], ["Room type", viewItem.roomType],
//                   ["Carpet area", viewItem.carpetArea ? `${viewItem.carpetArea} sq ft` : ""],
//                   ["Super area", viewItem.superArea ? `${viewItem.superArea} sq ft` : ""],
//                   ["Bedrooms", viewItem.bedrooms], ["Hall", viewItem.hall], ["Kitchen", viewItem.kitchen],
//                   ["Bathrooms", viewItem.bathrooms], ["Balcony", viewItem.balcony],
//                   ["Max guests", viewItem.maxGuests], ["Beds", viewItem.beds],
//                 ]} />
//                 <Info title="Pricing" rows={[
//                   ["Base price", inr(viewItem.pricing?.basePrice) + " per night"],
//                   ["Weekend price", viewItem.pricing?.weekendPrice ? inr(viewItem.pricing.weekendPrice) : ""],
//                   ["Monthly price", viewItem.pricing?.monthlyPrice ? inr(viewItem.pricing.monthlyPrice) : ""],
//                   ["Extra guest", viewItem.pricing?.extraGuestPrice ? inr(viewItem.pricing.extraGuestPrice) : ""],
//                   ["Cleaning fee", viewItem.pricing?.cleaningFee ? inr(viewItem.pricing.cleaningFee) : ""],
//                   ["Security deposit", viewItem.pricing?.securityDeposit ? inr(viewItem.pricing.securityDeposit) : ""],
//                 ]} />
//                 <Info title="Timings and policy" rows={[
//                   ["Check-in", viewItem.checkInTime], ["Check-out", viewItem.checkOutTime],
//                   ["Available from", dateOnly(viewItem.availableFrom)], ["Available to", dateOnly(viewItem.availableTo)],
//                   ["Meal plan", viewItem.mealPlan], ["Cancellation", viewItem.cancellationPolicy],
//                   ["Extra mattress", yn(viewItem.extraMattressAllowed)], ["Children", yn(viewItem.childrenAllowed)], ["Pets", yn(viewItem.petsAllowed)],
//                 ]} />
//                 <Info title="Food" rows={[
//                   ["Kitchen available", yn(viewItem.kitchenAvailable)], ["Self cooking", yn(viewItem.selfCookingAllowed)],
//                   ["Veg food", yn(viewItem.vegFoodAvailable)], ["Non-veg", yn(viewItem.nonVegAllowed)],
//                 ]} />
//                 <Info title="House rules" rows={Object.keys(RULE_LABELS).map((k) => [RULE_LABELS[k], viewItem.houseRules ? (viewItem.houseRules[k] ? "Allowed" : "Not allowed") : ""])} />
//               </div>

//               <h4 className="va-sub">Amenities</h4>
//               {viewItem.amenities?.length ? (
//                 <div className="chips">
//                   {viewItem.amenities.map((a) => <span key={a} className="chip on static">{a}</span>)}
//                 </div>
//               ) : (
//                 <p className="hint">No amenities listed.</p>
//               )}

//               {viewItem.notes && (
//                 <>
//                   <h4 className="va-sub">Internal notes</h4>
//                   <p className="desc">{viewItem.notes}</p>
//                 </>
//               )}
//             </div>

//             <div className="modal-foot">
//               <div />
//               <div>
//                 <button className="btn" onClick={() => setViewItem(null)}>Close</button>
//                 <button className="btn primary" onClick={() => openEdit(viewItem)}>Edit apartment</button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ==============================
//           DELETE CONFIRM
//       ============================== */}
//       {deleteItem && (
//         <div className="overlay" onMouseDown={() => !deleting && setDeleteItem(null)}>
//           <div className="modal small" role="alertdialog" aria-modal="true" onMouseDown={(e) => e.stopPropagation()}>
//             <div className="modal-body">
//               <h2 className="del-title">Delete this apartment?</h2>
//               <p className="desc">
//                 &ldquo;{deleteItem.apartmentName}&rdquo; and its photos will be removed. This cannot be undone.
//               </p>
//             </div>
//             <div className="modal-foot">
//               <div />
//               <div>
//                 <button className="btn" onClick={() => setDeleteItem(null)} disabled={deleting}>Keep apartment</button>
//                 <button className="btn danger-solid" onClick={confirmDelete} disabled={deleting}>
//                   {deleting ? "Deleting..." : "Delete apartment"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {toast && <div className={`toast ${toast.type}`} role="status">{toast.msg}</div>}
//     </div>
//   );
// }

// /* ── Sub-components ── */
// function Info({ title, rows }) {
//   const shown = rows.filter(([, v]) => v !== undefined && v !== null && v !== "");
//   if (shown.length === 0) return null;
//   return (
//     <section className="info">
//       <h4>{title}</h4>
//       {shown.map(([k, v]) => (
//         <div key={k} className="info-row">
//           <span>{k}</span>
//           <span>{String(v)}</span>
//         </div>
//       ))}
//     </section>
//   );
// }

// /* ==============================
//    STYLES
// ============================== */
// const css = `
// @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=Outfit:wght@400;500;600&display=swap');
// .va{--ink:#0f172a;--muted:#64748b;--line:#e2e8f0;--bg:#f5faff;--accent:#0369a1;--accent-d:#075985;--soft:#e0f2fe;--danger:#dc2626;
//   font-family:'Outfit',system-ui,sans-serif;color:var(--ink);background:var(--bg);min-height:100vh;max-width:1400px;margin:0 auto;padding:32px 24px}
// .va *{box-sizing:border-box}
// .va h1,.va h2{font-family:'Syne',sans-serif;margin:0}
// .va-head{display:flex;justify-content:space-between;align-items:flex-start;gap:16px;flex-wrap:wrap;margin-bottom:24px}
// .va-head h1{font-size:30px;color:#0c4a6e}
// .va-head p{margin:6px 0 0;color:var(--muted);font-size:14px}
// .btn{border:1px solid var(--line);background:#fff;color:var(--ink);padding:10px 18px;border-radius:8px;font:600 14px 'Outfit',sans-serif;cursor:pointer}
// .btn:hover:not(:disabled){border-color:#b6c4d3}
// .btn.sm{padding:6px 12px;font-size:13px}
// .btn.primary{background:var(--accent);border-color:var(--accent);color:#fff}
// .btn.primary:hover:not(:disabled){background:var(--accent-d)}
// .btn.soft{background:var(--soft);border-color:#bae6fd;color:var(--accent)}
// .btn.danger{color:var(--danger);border-color:#f3c4c4}
// .btn.danger-solid{background:var(--danger);border-color:var(--danger);color:#fff}
// .btn:disabled{opacity:.6;cursor:not-allowed}
// .va button:focus-visible,.va input:focus-visible,.va select:focus-visible,.va textarea:focus-visible,.va label:focus-within{outline:2px solid var(--accent);outline-offset:2px}
// .va-filters{display:flex;gap:12px;align-items:center;flex-wrap:wrap;margin-bottom:18px}
// .va-filters input,.va-filters select{padding:10px 14px;border:1.5px solid #bae6fd;border-radius:8px;font:14px 'Outfit',sans-serif;background:#fff}
// .va-filters input{flex:1;min-width:220px}
// .va-count{font-size:13px;color:var(--muted)}
// .va-state{background:#fff;border:1px dashed #bcd7ea;border-radius:14px;padding:64px 20px;text-align:center;color:var(--muted);display:flex;flex-direction:column;align-items:center;gap:14px}
// .va-state p{margin:0;font-size:15px}
// .va-state.err{color:var(--danger)}
// .spinner{width:38px;height:38px;border:3px solid #bae6fd;border-top-color:var(--accent);border-radius:50%;animation:va-spin 1s linear infinite}
// @keyframes va-spin{to{transform:rotate(360deg)}}
// .va-table-wrap{background:#fff;border-radius:14px;box-shadow:0 1px 4px rgba(15,23,42,.06);overflow-x:auto}
// .va table{width:100%;border-collapse:collapse;min-width:860px}
// .va th{padding:14px 16px;text-align:left;font-size:12px;font-weight:600;color:var(--accent);background:#f0f9ff;border-bottom:1px solid var(--soft)}
// .va td{padding:14px 16px;font-size:14px;border-bottom:1px solid #f0f6fb;vertical-align:middle}
// .va tbody tr:hover{background:#f8fcff}
// .va tr:last-child td{border-bottom:0}
// .right{text-align:right}
// .va td small{display:block;color:var(--muted);font-size:12px;margin-top:3px}
// .cell-apt{display:flex;align-items:center;gap:12px}
// .thumb{width:64px;height:52px;border-radius:8px;background:var(--soft);overflow:hidden;flex:none;display:flex;align-items:center;justify-content:center;font-size:10px;color:var(--muted)}
// .thumb img{width:100%;height:100%;object-fit:cover}
// .name-link{background:none;border:0;padding:0;font:600 14px 'Outfit',sans-serif;color:var(--ink);cursor:pointer;text-align:left}
// .name-link:hover{color:var(--accent);text-decoration:underline}
// .tag{font-size:12px;font-weight:600;color:var(--accent);background:var(--soft);padding:3px 10px;border-radius:999px}
// .status{font-size:12px;font-weight:600;padding:3px 11px;border-radius:999px;display:inline-block}
// .status.approved{background:var(--soft);color:var(--accent)}
// .status.pending{background:#fef3c7;color:#b45309}
// .status.rejected{background:#fee2e2;color:#b91c1c}
// .status.inactive{background:#f1f5f9;color:#475569}
// .mini{display:block;margin-top:6px;font:12px 'Outfit',sans-serif;background:none;border:1px solid #cbd5e1;border-radius:6px;padding:2px 9px;cursor:pointer;color:var(--muted)}
// .row-actions{display:inline-flex;gap:6px}

// /* modal */
// .overlay{position:fixed;inset:0;background:rgba(15,23,42,.55);display:flex;align-items:center;justify-content:center;padding:20px;z-index:1000;backdrop-filter:blur(3px)}
// .modal{background:#fff;border-radius:16px;width:100%;max-width:920px;max-height:calc(100vh - 40px);display:flex;flex-direction:column;box-shadow:0 24px 70px rgba(15,23,42,.3);overflow:hidden}
// .modal.small{max-width:430px}
// .modal-head{display:flex;justify-content:space-between;align-items:flex-start;gap:16px;padding:20px 28px;border-bottom:1px solid var(--soft);flex:none}
// .modal-head h2{font-size:22px}
// .modal-head p{margin:4px 0 0;color:var(--muted);font-size:13px}
// .head-right{display:flex;align-items:center;gap:12px}
// .x{background:var(--soft);border:0;border-radius:8px;width:36px;height:36px;font-size:22px;line-height:1;color:var(--accent);cursor:pointer;flex:none}
// .tabs{display:flex;gap:4px;padding:0 20px;border-bottom:1px solid var(--soft);overflow-x:auto;flex:none}
// .tab{background:none;border:0;border-bottom:3px solid transparent;padding:12px 12px;font:600 13px 'Outfit',sans-serif;color:var(--muted);cursor:pointer;white-space:nowrap}
// .tab:hover{color:var(--accent)}
// .tab.on{color:var(--accent);border-bottom-color:var(--accent)}
// .modal-body{padding:24px 28px;overflow-y:auto;flex:1;min-height:0}
// .modal-foot{display:flex;justify-content:space-between;align-items:center;gap:12px;flex-wrap:wrap;padding:14px 28px;border-top:1px solid var(--soft);background:#fff;flex:none}
// .modal-foot>div{display:flex;gap:8px;flex-wrap:wrap}
// .form-error{background:#fee2e2;color:#b91c1c;border:1px solid #fecaca;border-radius:8px;padding:10px 14px;font-size:14px;margin-bottom:16px}
// .grid{display:grid;grid-template-columns:repeat(2,1fr);gap:16px}
// .grid.checks{grid-template-columns:repeat(auto-fit,minmax(220px,1fr))}
// .full{grid-column:1/-1}
// .va-label{display:block;font-size:13px;font-weight:600;color:#334155;margin-bottom:6px}
// .va-sub{margin:20px 0 10px;font-size:14px;font-weight:600;color:#0c4a6e}
// .grid .va-sub:first-child{margin-top:0}
// .modal input[type=text],.modal input[type=tel],.modal input[type=email],.modal input[type=number],.modal input[type=date],.modal input[type=time],.modal select,.modal textarea{width:100%;padding:10px 13px;border:1.5px solid var(--line);border-radius:8px;font:14px 'Outfit',sans-serif;background:#fff;color:var(--ink)}
// .modal textarea{resize:vertical}
// .modal input:focus,.modal select:focus,.modal textarea:focus{border-color:var(--accent);box-shadow:0 0 0 3px rgba(3,105,161,.12);outline:none}
// .va-check{display:flex;align-items:center;gap:10px;padding:12px 14px;border:1.5px solid var(--line);border-radius:10px;font-size:14px;cursor:pointer;background:#fff}
// .va-check.on{background:#f0f9ff;border-color:#7dd3fc}
// .va-check input{width:16px;height:16px;accent-color:var(--accent)}
// .va-check.rule em{margin-left:auto;font-style:normal;font-size:12px;font-weight:600;color:var(--muted)}
// .va-check.rule.on em{color:var(--accent)}
// .hint{font-size:13px;color:var(--muted);margin:12px 0}
// .summary{margin-top:18px;background:#f0f9ff;border:1px solid #bae6fd;border-radius:10px;padding:14px 16px;display:flex;flex-direction:column;gap:4px;font-size:13px}
// .summary strong{color:var(--accent);margin-bottom:4px}
// .chips{display:flex;flex-wrap:wrap;gap:10px}
// .chip{padding:8px 16px;border:1.5px solid var(--line);border-radius:999px;background:#fff;font:500 13px 'Outfit',sans-serif;color:#475569;cursor:pointer}
// .chip:hover{border-color:var(--accent);color:var(--accent)}
// .chip.on{background:var(--accent);border-color:var(--accent);color:#fff}
// .chip.static{cursor:default;padding:6px 14px}
// .photos{display:grid;grid-template-columns:repeat(auto-fill,120px);gap:14px}
// .photo{width:120px;height:96px;border-radius:8px;position:relative;background:var(--soft)}
// .photo img{width:100%;height:100%;object-fit:cover;border-radius:8px}
// .photo.add{border:2px dashed #7dd3fc;background:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;font-size:12px;color:var(--muted);cursor:pointer}
// .photo.add span{font-size:26px;line-height:1;color:var(--accent)}
// .rm{position:absolute;top:-8px;right:-8px;width:24px;height:24px;border-radius:50%;border:0;background:var(--danger);color:#fff;font-size:16px;line-height:1;cursor:pointer}
// .badge{position:absolute;left:6px;bottom:6px;background:var(--accent);color:#fff;font-size:11px;font-weight:600;padding:2px 8px;border-radius:4px}

// /* full page screens (add / edit / view) */
// .page-wrap{max-width:1000px;margin:0 auto}
// .back{background:none;border:0;padding:6px 0;margin-bottom:12px;font:600 14px 'Outfit',sans-serif;color:var(--accent);cursor:pointer}
// .back:hover{text-decoration:underline}
// .page-card{background:#fff;border-radius:16px;box-shadow:0 2px 14px rgba(15,23,42,.08);display:flex;flex-direction:column}
// .page-card .modal-head{position:sticky;top:0;z-index:5;background:#fff;border-radius:16px 16px 0 0}
// .page-card .modal-body{overflow:visible;flex:none;min-height:420px}
// .page-card .modal-foot{position:sticky;bottom:0;z-index:5;border-radius:0 0 16px 16px;box-shadow:0 -4px 14px rgba(15,23,42,.05)}
// .page-card .tabs{background:#fff}

// /* view modal */
// .gallery{margin-bottom:18px}
// .gallery .main{width:100%;max-height:340px;object-fit:cover;border-radius:12px;display:block;background:var(--soft)}
// .strip{display:flex;gap:8px;margin-top:10px;overflow-x:auto}
// .strip button{border:2px solid transparent;border-radius:8px;padding:0;background:none;cursor:pointer;flex:none;opacity:.7}
// .strip button.on{border-color:var(--accent);opacity:1}
// .strip img{width:84px;height:62px;object-fit:cover;border-radius:6px;display:block}
// .desc{margin:0 0 18px;font-size:14px;line-height:1.6;color:#334155;white-space:pre-line}
// .view-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:16px}
// .info{border:1px solid var(--line);border-radius:12px;padding:14px 16px}
// .info h4{margin:0 0 8px;font-size:14px;color:#0c4a6e}
// .info-row{display:flex;justify-content:space-between;gap:14px;padding:5px 0;font-size:13px;border-bottom:1px solid #f1f5f9}
// .info-row:last-child{border-bottom:0}
// .info-row span:first-child{color:var(--muted);flex:none}
// .info-row span:last-child{text-align:right;word-break:break-word;font-weight:500}
// .del-title{font-size:20px;margin-bottom:10px}
// .toast{position:fixed;top:20px;right:20px;z-index:2000;padding:12px 18px;border-radius:10px;font-size:14px;font-weight:500;color:#fff;background:var(--accent);box-shadow:0 6px 24px rgba(15,23,42,.2)}
// .toast.err{background:var(--danger)}

// @media (max-width:700px){
//   .va{padding:20px 14px}
//   .overlay{padding:16px}
//   .modal{max-width:100%}
//   .page-card,.page-card .modal-head,.page-card .modal-foot{border-radius:12px}
//   .page-card .modal-head{border-radius:12px 12px 0 0}
//   .page-card .modal-foot{border-radius:0 0 12px 12px}
//   .modal-head,.modal-body,.modal-foot{padding-left:16px;padding-right:16px}
//   .grid,.view-grid{grid-template-columns:1fr}
// }
// @media (prefers-reduced-motion:reduce){.spinner{animation-duration:3s}}
// `;


import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";

/* ==============================
   CONFIG
============================== */
const BASE =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_URL) ||
  "https://bmtvendorvendorfinal.onrender.com";
const API = `${BASE}/api/vendor/apartment`;

const AMENITIES = ["WiFi", "AC", "TV", "Parking", "Lift", "Geyser", "Power Backup", "Security", "CCTV", "Intercom", "Gym", "Swimming Pool", "Garden", "Club House", "Play Area", "Visitor Parking"];
const APARTMENT_TYPES = ["Studio", "1BHK", "2BHK", "3BHK", "4BHK", "Penthouse"];
const FURNISHING_TYPES = ["Fully Furnished", "Semi Furnished", "Unfurnished"];
const ROOM_TYPES = ["Entire Apartment", "Private Room", "Shared Room"];
const MEAL_PLANS = ["Room Only", "Breakfast", "Breakfast and Dinner", "All Meals", "Custom"];
const CANCELLATION = ["Flexible", "Moderate", "Strict", "Non-Refundable"];

const DEFAULT_RULES = { smoking: false, alcohol: false, parties: false, loudMusic: false, unmarriedCouples: false, localIdAllowed: false };
const RULE_LABELS = { smoking: "Smoking", alcohol: "Alcohol", parties: "Parties", loudMusic: "Loud music", unmarriedCouples: "Unmarried couples", localIdAllowed: "Local ID accepted" };

const DEFAULT_FORM = {
  apartmentName: "", propertyType: "Apartment", description: "", hostName: "",
  phone: "", altPhone: "", email: "",
  country: "India", state: "", city: "", area: "", address: "", pincode: "", landmark: "",
  lat: "", lng: "",
  buildingName: "", towerName: "", floorNumber: "", totalFloors: "", flatNumber: "", societyName: "",
  apartmentType: "1BHK", furnishing: "Fully Furnished",
  carpetArea: "", superArea: "",
  bedrooms: "", hall: "", kitchen: "", bathrooms: "", balcony: "",
  maxGuests: "", beds: "",
  extraMattressAllowed: false, childrenAllowed: false, petsAllowed: false,
  kitchenAvailable: false, selfCookingAllowed: false, vegFoodAvailable: false, nonVegAllowed: false,
  basePrice: "", monthlyPrice: "", weekendPrice: "", extraGuestPrice: "", cleaningFee: "", securityDeposit: "",
  checkInTime: "14:00", checkOutTime: "11:00",
  availableFrom: "", availableTo: "",
  roomType: "Entire Apartment", mealPlan: "Room Only", cancellationPolicy: "Moderate", notes: "",
};

/* ==============================
   FORM CONFIG (step wise)
============================== */
const F = (k, l, t = "text", x = {}) => ({ k, l, t, ...x });
const H = (h) => ({ h });

const STEPS = [
  { id: "basic", label: "Basic info", hint: "Name, host and contact" },
  { id: "location", label: "Location", hint: "Where guests will stay" },
  { id: "building", label: "Building", hint: "Tower, floor, flat" },
  { id: "details", label: "Details", hint: "Rooms, capacity, timings" },
  { id: "amenities", label: "Amenities", hint: "What guests can use" },
  { id: "food", label: "Food", hint: "Kitchen and meals" },
  { id: "pricing", label: "Pricing", hint: "Nightly and monthly rates" },
  { id: "rules", label: "House rules", hint: "What is allowed" },
  { id: "media", label: "Photos", hint: "Show off your place" },
];

const FIELDS = {
  basic: [
    F("apartmentName", "Apartment name *", "text", { full: true, ph: "e.g., Skyline 2BHK Apartment" }),
    F("hostName", "Host name", "text", { ph: "Owner or host name" }),
    F("phone", "Phone", "tel", { ph: "+91 XXXXX XXXXX" }),
    F("altPhone", "Alternate phone", "tel", { ph: "+91 XXXXX XXXXX" }),
    F("email", "Email", "email", { ph: "host@email.com" }),
    F("description", "Description", "textarea", { full: true, ph: "Layout, views, neighbourhood, nearby attractions..." }),
    F("roomType", "Room type", "select", { o: ROOM_TYPES }),
    F("mealPlan", "Meal plan", "select", { o: MEAL_PLANS }),
    F("cancellationPolicy", "Cancellation policy", "select", { o: CANCELLATION }),
    F("notes", "Internal notes", "text", { ph: "Only visible to you" }),
  ],
  location: [
    F("address", "Full address *", "text", { full: true, ph: "Flat no, building, street..." }),
    F("city", "City *", "text", { ph: "e.g., Mumbai" }),
    F("area", "Area / locality", "text", { ph: "e.g., Bandra West" }),
    F("state", "State", "text", { ph: "e.g., Maharashtra" }),
    F("pincode", "Pincode", "text", { ph: "e.g., 400050" }),
    F("country", "Country", "text"),
    F("landmark", "Landmark", "text", { ph: "Near XYZ mall" }),
    F("lat", "Latitude", "text", { ph: "e.g., 19.0760" }),
    F("lng", "Longitude", "text", { ph: "e.g., 72.8777" }),
  ],
  building: [
    F("buildingName", "Building name", "text", { ph: "e.g., Oberoi Splendor" }),
    F("societyName", "Society / complex", "text", { ph: "e.g., Green Park Society" }),
    F("towerName", "Tower", "text", { ph: "e.g., Tower A" }),
    F("flatNumber", "Flat number", "text", { ph: "e.g., 1204" }),
    F("floorNumber", "Floor number", "number", { ph: "e.g., 12" }),
    F("totalFloors", "Total floors in building", "number", { ph: "e.g., 25" }),
  ],
  details: [
    F("apartmentType", "Apartment type", "select", { o: APARTMENT_TYPES }),
    F("furnishing", "Furnishing", "select", { o: FURNISHING_TYPES }),
    F("carpetArea", "Carpet area (sq ft)", "number", { ph: "e.g., 850" }),
    F("superArea", "Super area (sq ft)", "number", { ph: "e.g., 1100" }),
    F("bedrooms", "Bedrooms", "number"),
    F("hall", "Hall", "number"),
    F("kitchen", "Kitchen", "number"),
    F("bathrooms", "Bathrooms", "number"),
    F("balcony", "Balcony", "number"),
    F("maxGuests", "Max guests", "number"),
    F("beds", "Beds", "number"),
    H("Availability and timings"),
    F("availableFrom", "Available from", "date"),
    F("availableTo", "Available to", "date"),
    F("checkInTime", "Check-in time", "time"),
    F("checkOutTime", "Check-out time", "time"),
    H("Guest policy"),
    F("extraMattressAllowed", "Extra mattress allowed", "checkbox"),
    F("childrenAllowed", "Children allowed", "checkbox"),
    F("petsAllowed", "Pets allowed", "checkbox"),
  ],
  food: [
    F("kitchenAvailable", "Kitchen available", "checkbox"),
    F("selfCookingAllowed", "Self cooking allowed", "checkbox"),
    F("vegFoodAvailable", "Veg food available", "checkbox"),
    F("nonVegAllowed", "Non-veg allowed", "checkbox"),
  ],
  pricing: [
    F("basePrice", "Base price per night (INR) *", "number", { ph: "e.g., 2500" }),
    F("monthlyPrice", "Monthly price (INR)", "number", { ph: "e.g., 35000" }),
    F("weekendPrice", "Weekend price (INR)", "number", { ph: "e.g., 3000" }),
    F("extraGuestPrice", "Extra guest price (INR)", "number", { ph: "e.g., 400" }),
    F("cleaningFee", "Cleaning fee (INR)", "number", { ph: "e.g., 250" }),
    F("securityDeposit", "Security deposit (INR)", "number", { ph: "e.g., 10000" }),
  ],
};

const NUMERIC_KEYS = ["floorNumber", "totalFloors", "carpetArea", "superArea", "bedrooms", "hall", "kitchen", "bathrooms", "balcony", "maxGuests", "beds", "basePrice", "monthlyPrice", "weekendPrice", "extraGuestPrice", "cleaningFee", "securityDeposit"];

/* ==============================
   HELPERS
============================== */
const inr = (n) =>
  n === undefined || n === null || n === ""
    ? "-"
    : new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(Number(n));

const nv = (x, d = "") => (x === undefined || x === null ? d : x);
const dateOnly = (v) => (v ? String(v).split("T")[0] : "");
const yn = (b) => (b ? "Yes" : "No");
// Approval nahi hai: sirf "inactive" band hai, baaki sab live
const isActive = (a) => (a.status || "active") !== "inactive";

function apartmentToForm(a) {
  return {
    apartmentName: nv(a.apartmentName), propertyType: nv(a.propertyType, "Apartment"),
    description: nv(a.description), hostName: nv(a.hostName),
    phone: nv(a.phone), altPhone: nv(a.altPhone), email: nv(a.email),
    country: nv(a.country, "India"), state: nv(a.state), city: nv(a.city),
    area: nv(a.area), address: nv(a.address), pincode: nv(a.pincode), landmark: nv(a.landmark),
    lat: nv(a.mapLocation?.lat), lng: nv(a.mapLocation?.lng),
    buildingName: nv(a.buildingName), towerName: nv(a.towerName),
    floorNumber: nv(a.floorNumber), totalFloors: nv(a.totalFloors),
    flatNumber: nv(a.flatNumber), societyName: nv(a.societyName),
    apartmentType: nv(a.apartmentType, "1BHK"), furnishing: nv(a.furnishing, "Fully Furnished"),
    carpetArea: nv(a.carpetArea), superArea: nv(a.superArea),
    bedrooms: nv(a.bedrooms), hall: nv(a.hall), kitchen: nv(a.kitchen),
    bathrooms: nv(a.bathrooms), balcony: nv(a.balcony),
    maxGuests: nv(a.maxGuests), beds: nv(a.beds),
    extraMattressAllowed: !!a.extraMattressAllowed, childrenAllowed: !!a.childrenAllowed, petsAllowed: !!a.petsAllowed,
    kitchenAvailable: !!a.kitchenAvailable, selfCookingAllowed: !!a.selfCookingAllowed,
    vegFoodAvailable: !!a.vegFoodAvailable, nonVegAllowed: !!a.nonVegAllowed,
    basePrice: nv(a.pricing?.basePrice), monthlyPrice: nv(a.pricing?.monthlyPrice),
    weekendPrice: nv(a.pricing?.weekendPrice), extraGuestPrice: nv(a.pricing?.extraGuestPrice),
    cleaningFee: nv(a.pricing?.cleaningFee), securityDeposit: nv(a.pricing?.securityDeposit),
    checkInTime: nv(a.checkInTime, "14:00"), checkOutTime: nv(a.checkOutTime, "11:00"),
    availableFrom: dateOnly(a.availableFrom), availableTo: dateOnly(a.availableTo),
    roomType: nv(a.roomType, "Entire Apartment"), mealPlan: nv(a.mealPlan, "Room Only"),
    cancellationPolicy: nv(a.cancellationPolicy, "Moderate"), notes: nv(a.notes),
  };
}

function validate(form, photoCount) {
  if (!form.apartmentName.trim()) return { tab: "basic", msg: "Apartment name is required." };
  if (form.email && !/^\S+@\S+\.\S+$/.test(form.email)) return { tab: "basic", msg: "Enter a valid email address." };
  if (!form.address.trim()) return { tab: "location", msg: "Full address is required." };
  if (!form.city.trim()) return { tab: "location", msg: "City is required." };
  if (form.availableFrom && form.availableTo && form.availableFrom > form.availableTo)
    return { tab: "details", msg: "Available-from date must be before available-to date." };
  if (form.basePrice === "" || Number(form.basePrice) <= 0) return { tab: "pricing", msg: "Base price per night is required." };
  for (const k of NUMERIC_KEYS) {
    if (form[k] !== "" && Number(form[k]) < 0) {
      const tab = Object.entries(FIELDS).find(([, list]) => list.some((x) => x.k === k))?.[0] || "basic";
      return { tab, msg: "Numbers cannot be negative." };
    }
  }
  if (photoCount === 0) return { tab: "media", msg: "Upload at least one photo." };
  return null;
}

/* ==============================
   MAIN COMPONENT
============================== */
export default function VendorApartment() {
  const token = localStorage.getItem("vendorToken") || localStorage.getItem("token");
  const authHeaders = useMemo(() => ({ headers: { Authorization: `Bearer ${token}` } }), [token]);

  const [apartments, setApartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageError, setPageError] = useState("");
  const [toast, setToast] = useState(null);
  const [search, setSearch] = useState("");
  const [filterStatus, setFilterStatus] = useState("");

  // form
  const [formOpen, setFormOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState(DEFAULT_FORM);
  const [rules, setRules] = useState(DEFAULT_RULES);
  const [amenities, setAmenities] = useState([]);
  const [existingImages, setExistingImages] = useState([]);
  const [removedImages, setRemovedImages] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [activeTab, setActiveTab] = useState("basic");
  const [formError, setFormError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const snapshot = useRef("");

  // view / delete
  const [viewItem, setViewItem] = useState(null);
  const [viewImg, setViewImg] = useState(0);
  const [deleteItem, setDeleteItem] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const showToast = (msg, type = "ok") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3200);
  };

  /* ---------- load ---------- */
  const fetchApartments = useCallback(async () => {
    setPageError("");
    try {
      const res = await axios.get(API, authHeaders);
      setApartments(res.data.data || []);
    } catch (e) {
      setPageError(
        e.response?.status === 401
          ? "Session expired. Please login again."
          : e.response?.data?.message || "Failed to load apartments."
      );
    } finally {
      setLoading(false);
    }
  }, [authHeaders]);

  useEffect(() => {
    if (!token) {
      setLoading(false);
      setPageError("Session not found. Please login again.");
      return;
    }
    fetchApartments();
  }, [token, fetchApartments]);

  const stats = useMemo(() => {
    const active = apartments.filter(isActive).length;
    return { total: apartments.length, active, inactive: apartments.length - active };
  }, [apartments]);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    return apartments.filter((a) => {
      const matchQ = !q || a.apartmentName?.toLowerCase().includes(q) || a.city?.toLowerCase().includes(q) || a.area?.toLowerCase().includes(q);
      const matchS = !filterStatus || (filterStatus === "active" ? isActive(a) : !isActive(a));
      return matchQ && matchS;
    });
  }, [apartments, search, filterStatus]);

  /* ---------- screen plumbing ---------- */
  useEffect(() => {
    document.body.style.overflow = deleteItem ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [deleteItem]);

  const screenKey = formOpen ? "form" : viewItem ? "view" : "list";
  useEffect(() => { window.scrollTo({ top: 0 }); }, [screenKey]);

  const isDirty = () =>
    JSON.stringify({ form, rules, amenities }) !== snapshot.current || newFiles.length > 0 || removedImages.length > 0;

  const resetForm = () => {
    newFiles.forEach((n) => URL.revokeObjectURL(n.url));
    setFormOpen(false);
    setEditId(null);
    setForm(DEFAULT_FORM);
    setRules(DEFAULT_RULES);
    setAmenities([]);
    setExistingImages([]);
    setRemovedImages([]);
    setNewFiles([]);
    setActiveTab("basic");
    setFormError("");
  };

  const requestCloseForm = () => {
    if (submitting) return;
    if (isDirty() && !window.confirm("Close without saving? Your changes will be lost.")) return;
    resetForm();
  };

  useEffect(() => {
    const onKey = (e) => {
      if (e.key !== "Escape") return;
      if (deleteItem) return !deleting && setDeleteItem(null);
      if (viewItem) return setViewItem(null);
      if (formOpen) requestCloseForm();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  });

  const openAdd = () => {
    resetForm();
    snapshot.current = JSON.stringify({ form: DEFAULT_FORM, rules: DEFAULT_RULES, amenities: [] });
    setFormOpen(true);
  };

  const openEdit = (a) => {
    resetForm();
    const f = apartmentToForm(a);
    const r = { ...DEFAULT_RULES, ...(a.houseRules || {}) };
    const am = a.amenities || [];
    snapshot.current = JSON.stringify({ form: f, rules: r, amenities: am });
    setEditId(a._id);
    setForm(f);
    setRules(r);
    setAmenities(am);
    setExistingImages(a.images || []);
    setViewItem(null);
    setFormOpen(true);
  };

  const setField = (k, v) => setForm((p) => ({ ...p, [k]: v }));
  const toggleAmenity = (a) => setAmenities((p) => (p.includes(a) ? p.filter((x) => x !== a) : [...p, a]));
  const toggleRule = (k) => setRules((p) => ({ ...p, [k]: !p[k] }));

  const handleImages = (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    const valid = files.filter((f) => f.type.startsWith("image/") && f.size <= 5 * 1024 * 1024);
    if (valid.length !== files.length) setFormError("Only image files up to 5 MB are allowed.");
    if (existingImages.length + newFiles.length + valid.length > 10) {
      setFormError("You can upload a maximum of 10 photos.");
      return;
    }
    setNewFiles((p) => [...p, ...valid.map((file) => ({ file, url: URL.createObjectURL(file) }))]);
  };

  const removeNewFile = (i) =>
    setNewFiles((p) => {
      URL.revokeObjectURL(p[i].url);
      return p.filter((_, idx) => idx !== i);
    });

  const removeExisting = (src) => {
    setExistingImages((p) => p.filter((x) => x !== src));
    setRemovedImages((p) => [...p, src]);
  };

  /* ---------- submit ---------- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    const problem = validate(form, existingImages.length + newFiles.length);
    if (problem) {
      setActiveTab(problem.tab);
      setFormError(problem.msg);
      return;
    }

    setSubmitting(true);
    setFormError("");

    const data = new FormData();
    Object.entries(form).forEach(([k, v]) => data.append(k, v));
    data.append("amenities", JSON.stringify(amenities));
    data.append("houseRules", JSON.stringify(rules));
    if (editId) data.append("removedImages", JSON.stringify(removedImages));
    newFiles.forEach((n) => data.append("images", n.file));

    const cfg = { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } };
    try {
      if (editId) await axios.put(`${API}/${editId}`, data, cfg);
      else await axios.post(API, data, cfg);
      showToast(editId ? "Apartment updated." : "Apartment is live.");
      resetForm();
      fetchApartments();
    } catch (err) {
      setFormError(err.response?.data?.message || "Could not save the apartment. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  /* ---------- delete / toggle ---------- */
  const confirmDelete = async () => {
    setDeleting(true);
    try {
      await axios.delete(`${API}/${deleteItem._id}`, authHeaders);
      setApartments((p) => p.filter((a) => a._id !== deleteItem._id));
      setDeleteItem(null);
      showToast("Apartment deleted.");
    } catch (err) {
      showToast(err.response?.data?.message || "Delete failed.", "err");
    } finally {
      setDeleting(false);
    }
  };

  const handleToggle = async (a) => {
    try {
      const res = await axios.patch(`${API}/${a._id}/toggle`, {}, authHeaders);
      const updated = res.data.data;
      setApartments((p) => p.map((x) => (x._id === a._id ? { ...x, ...updated } : x)));
      setViewItem((v) => (v && v._id === a._id ? { ...v, ...updated } : v));
      showToast(isActive(updated) ? "Apartment is now active." : "Apartment is now inactive.");
    } catch (err) {
      showToast(err.response?.data?.message || "Status change failed.", "err");
    }
  };

  /* ---------- render helpers ---------- */
  const renderField = (x, i) => {
    if (x.h) return <h4 key={`h${i}`} className="sub full">{x.h}</h4>;
    const id = `f-${x.k}`;
    if (x.t === "checkbox")
      return (
        <label key={x.k} className={`check ${form[x.k] ? "on" : ""}`}>
          <input type="checkbox" checked={!!form[x.k]} onChange={(e) => setField(x.k, e.target.checked)} />
          {x.l}
        </label>
      );
    return (
      <div key={x.k} className={x.full ? "full" : ""}>
        <label htmlFor={id} className="lbl">{x.l}</label>
        {x.t === "select" ? (
          <select id={id} value={form[x.k]} onChange={(e) => setField(x.k, e.target.value)}>
            {x.o.map((o) => <option key={o}>{o}</option>)}
          </select>
        ) : x.t === "textarea" ? (
          <textarea id={id} rows={4} value={form[x.k]} placeholder={x.ph} onChange={(e) => setField(x.k, e.target.value)} />
        ) : (
          <input id={id} type={x.t} min={x.t === "number" ? 0 : undefined} value={form[x.k]} placeholder={x.ph} onChange={(e) => setField(x.k, e.target.value)} />
        )}
      </div>
    );
  };

  const stepIndex = STEPS.findIndex((t) => t.id === activeTab);
  const totalPhotos = existingImages.length + newFiles.length;

  /* ==============================
     JSX
  ============================== */
  return (
    <div className="va">
      <style>{css}</style>

      {/* ============ LIST SCREEN ============ */}
      {!formOpen && !viewItem && (
        <>
          <header className="hero">
            <div>
              <span className="eyebrow">Vendor panel</span>
              <h1>My apartments</h1>
              <p>Add a listing and it goes live right away. Switch it off any time.</p>
            </div>
            <button className="btn primary lg" onClick={openAdd}>+ Add apartment</button>
          </header>

          <div className="stats">
            <div className="stat"><span>Total listings</span><strong>{stats.total}</strong></div>
            <div className="stat"><span>Active</span><strong className="g">{stats.active}</strong></div>
            <div className="stat"><span>Inactive</span><strong className="m">{stats.inactive}</strong></div>
          </div>

          <div className="toolbar">
            <input type="search" placeholder="Search by name, city or area" value={search} onChange={(e) => setSearch(e.target.value)} />
            <div className="seg" role="group" aria-label="Filter by status">
              {[["", "All"], ["active", "Active"], ["inactive", "Inactive"]].map(([v, l]) => (
                <button key={v} className={filterStatus === v ? "on" : ""} onClick={() => setFilterStatus(v)}>{l}</button>
              ))}
            </div>
            <span className="count">{filtered.length} of {apartments.length}</span>
          </div>

          {loading ? (
            <div className="state"><div className="spinner" /></div>
          ) : pageError ? (
            <div className="state err">
              <p>{pageError}</p>
              <button className="btn" onClick={() => { setLoading(true); fetchApartments(); }}>Try again</button>
            </div>
          ) : filtered.length === 0 ? (
            <div className="state">
              <div className="empty-ico">⌂</div>
              <p>{apartments.length === 0 ? "You have not added any apartments yet." : "No apartments match your filters."}</p>
              {apartments.length === 0 && <button className="btn primary" onClick={openAdd}>Add your first apartment</button>}
            </div>
          ) : (
            <div className="cards">
              {filtered.map((a) => {
                const on = isActive(a);
                const open = () => { setViewImg(0); setViewItem(a); };
                return (
                  <article key={a._id} className={`card ${on ? "" : "off"}`}>
                    <button className="card-img" onClick={open} aria-label={`View ${a.apartmentName}`}>
                      {a.images?.[0] ? <img src={a.images[0]} alt="" onError={(e) => (e.target.style.display = "none")} /> : <span className="noimg">No photo</span>}
                      <span className="pill type">{a.apartmentType || "Apartment"}</span>
                      {!on && <span className="pill paused">Inactive</span>}
                      <span className="price">{inr(a.pricing?.basePrice)}<small> / night</small></span>
                    </button>
                    <div className="card-body">
                      <h3 title={a.apartmentName}>{a.apartmentName}</h3>
                      <p className="loc">{[a.area, a.city, a.state].filter(Boolean).join(", ") || "Location not added"}</p>
                      <ul className="specs">
                        {a.bedrooms ? <li>{a.bedrooms} bed</li> : null}
                        {a.bathrooms ? <li>{a.bathrooms} bath</li> : null}
                        {a.maxGuests ? <li>{a.maxGuests} guests</li> : null}
                        {a.furnishing ? <li>{a.furnishing}</li> : null}
                      </ul>
                    </div>
                    <div className="card-foot">
                      <label className="switch" title={on ? "Click to deactivate" : "Click to activate"}>
                        <input type="checkbox" checked={on} onChange={() => handleToggle(a)} />
                        <span className="track" />
                        <span className="sw-text">{on ? "Active" : "Inactive"}</span>
                      </label>
                      <div className="acts">
                        <button className="btn sm" onClick={open}>View</button>
                        <button className="btn sm" onClick={() => openEdit(a)}>Edit</button>
                        <button className="btn sm danger" onClick={() => setDeleteItem(a)}>Delete</button>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>
          )}
        </>
      )}

      {/* ============ ADD / EDIT SCREEN ============ */}
      {formOpen && (
        <div className="page-wrap">
          <button type="button" className="back" onClick={requestCloseForm}>&larr; Back to apartments</button>
          <form className="panel" onSubmit={handleSubmit} noValidate aria-labelledby="form-title">
            <div className="panel-head">
              <div>
                <h2 id="form-title">{editId ? "Edit apartment" : "Add apartment"}</h2>
                <p>{editId ? "Changes are saved to your live listing." : "Your listing goes live as soon as you save."}</p>
              </div>
              <span className="step-count">Step {stepIndex + 1} / {STEPS.length}</span>
            </div>
            <div className="progress"><i style={{ width: `${((stepIndex + 1) / STEPS.length) * 100}%` }} /></div>

            <div className="form-layout">
              <nav className="steps" aria-label="Form steps">
                {STEPS.map((t, i) => (
                  <button key={t.id} type="button" className={`step ${activeTab === t.id ? "on" : ""} ${i < stepIndex ? "done" : ""}`} aria-current={activeTab === t.id ? "step" : undefined} onClick={() => setActiveTab(t.id)}>
                    <span className="num">{i < stepIndex ? "✓" : i + 1}</span>
                    <span className="st"><b>{t.label}</b><small>{t.hint}</small></span>
                  </button>
                ))}
              </nav>

              <div className="form-main">
                {formError && <div className="form-error" role="alert">{formError}</div>}
                <h3 className="step-title">{STEPS[stepIndex].label}</h3>

                {FIELDS[activeTab] && (
                  <div className={activeTab === "food" ? "grid checks" : "grid"}>{FIELDS[activeTab].map(renderField)}</div>
                )}

                {activeTab === "pricing" && form.basePrice !== "" && (
                  <div className="summary">
                    <strong>Pricing summary</strong>
                    <span>Nightly: {inr(form.basePrice)}</span>
                    {form.weekendPrice !== "" && <span>Weekend: {inr(form.weekendPrice)} per night</span>}
                    {form.monthlyPrice !== "" && <span>Monthly: {inr(form.monthlyPrice)}</span>}
                    {form.securityDeposit !== "" && <span>Security deposit: {inr(form.securityDeposit)}</span>}
                  </div>
                )}

                {activeTab === "amenities" && (
                  <>
                    <p className="hint">Select everything guests can use in this apartment.</p>
                    <div className="chips">
                      {AMENITIES.map((a) => (
                        <button key={a} type="button" aria-pressed={amenities.includes(a)} className={`chip ${amenities.includes(a) ? "on" : ""}`} onClick={() => toggleAmenity(a)}>{a}</button>
                      ))}
                    </div>
                    <p className="hint">{amenities.length} selected</p>
                  </>
                )}

                {activeTab === "rules" && (
                  <>
                    <p className="hint">Mark what guests are allowed to do.</p>
                    <div className="grid">
                      {Object.keys(rules).map((k) => (
                        <label key={k} className={`check rule ${rules[k] ? "on" : ""}`}>
                          <input type="checkbox" checked={rules[k]} onChange={() => toggleRule(k)} />
                          <span>{RULE_LABELS[k]}</span>
                          <em>{rules[k] ? "Allowed" : "Not allowed"}</em>
                        </label>
                      ))}
                    </div>
                  </>
                )}

                {activeTab === "media" && (
                  <>
                    <p className="hint">The first photo is the cover image. Up to 10 photos, 5 MB each.</p>
                    <div className="photos">
                      {existingImages.map((src, i) => (
                        <div key={src} className="photo">
                          <img src={src} alt="" onError={(e) => (e.target.style.display = "none")} />
                          <button type="button" className="rm" aria-label="Remove photo" onClick={() => removeExisting(src)}>&times;</button>
                          {i === 0 && <span className="badge">Cover</span>}
                        </div>
                      ))}
                      {newFiles.map((n, i) => (
                        <div key={n.url} className="photo">
                          <img src={n.url} alt="" />
                          <button type="button" className="rm" aria-label="Remove photo" onClick={() => removeNewFile(i)}>&times;</button>
                          <span className="badge new">{existingImages.length === 0 && i === 0 ? "Cover" : "New"}</span>
                        </div>
                      ))}
                      {totalPhotos < 10 && (
                        <label className="photo add">
                          <span>+</span>Add photos
                          <input type="file" multiple accept="image/*" hidden onChange={handleImages} />
                        </label>
                      )}
                    </div>
                    <p className="hint">{totalPhotos} of 10 photos</p>
                  </>
                )}
              </div>
            </div>

            <div className="panel-foot">
              <div>
                {stepIndex > 0 && <button type="button" className="btn" onClick={() => setActiveTab(STEPS[stepIndex - 1].id)}>Back</button>}
                {stepIndex < STEPS.length - 1 && <button type="button" className="btn soft" onClick={() => setActiveTab(STEPS[stepIndex + 1].id)}>Next</button>}
              </div>
              <div>
                <button type="button" className="btn" onClick={requestCloseForm} disabled={submitting}>Cancel</button>
                <button type="submit" className="btn primary" disabled={submitting}>
                  {submitting ? "Saving..." : editId ? "Update apartment" : "Save and go live"}
                </button>
              </div>
            </div>
          </form>
        </div>
      )}

      {/* ============ VIEW SCREEN ============ */}
      {viewItem && (
        <div className="page-wrap">
          <button type="button" className="back" onClick={() => setViewItem(null)}>&larr; Back to apartments</button>
          <div className="panel">
            <div className="panel-head">
              <div>
                <h2>{viewItem.apartmentName}</h2>
                <p>{[viewItem.area, viewItem.city, viewItem.state].filter(Boolean).join(", ")}</p>
              </div>
              <label className="switch" title="Toggle listing status">
                <input type="checkbox" checked={isActive(viewItem)} onChange={() => handleToggle(viewItem)} />
                <span className="track" />
                <span className="sw-text">{isActive(viewItem) ? "Active" : "Inactive"}</span>
              </label>
            </div>

            <div className="view-body">
              {viewItem.images?.length > 0 && (
                <div className="gallery">
                  <img className="main" src={viewItem.images[viewImg] || viewItem.images[0]} alt="" />
                  {viewItem.images.length > 1 && (
                    <div className="strip">
                      {viewItem.images.map((src, i) => (
                        <button key={src + i} className={i === viewImg ? "on" : ""} onClick={() => setViewImg(i)}><img src={src} alt="" /></button>
                      ))}
                    </div>
                  )}
                </div>
              )}

              <div className="price-line">
                <strong>{inr(viewItem.pricing?.basePrice)}</strong><span>per night</span>
                {viewItem.pricing?.monthlyPrice ? <em>{inr(viewItem.pricing.monthlyPrice)} per month</em> : null}
              </div>

              {viewItem.description && <p className="desc">{viewItem.description}</p>}

              <div className="view-grid">
                <Info title="Host and contact" rows={[["Host", viewItem.hostName], ["Phone", viewItem.phone], ["Alternate phone", viewItem.altPhone], ["Email", viewItem.email]]} />
                <Info title="Address" rows={[
                  ["Address", viewItem.address], ["Area", viewItem.area], ["City", viewItem.city], ["State", viewItem.state],
                  ["Pincode", viewItem.pincode], ["Country", viewItem.country], ["Landmark", viewItem.landmark],
                  ["Map", viewItem.mapLocation?.lat != null && viewItem.mapLocation?.lng != null ? `${viewItem.mapLocation.lat}, ${viewItem.mapLocation.lng}` : ""],
                ]} />
                <Info title="Building" rows={[
                  ["Building", viewItem.buildingName], ["Society", viewItem.societyName], ["Tower", viewItem.towerName], ["Flat number", viewItem.flatNumber],
                  ["Floor", viewItem.floorNumber !== undefined && viewItem.floorNumber !== null && viewItem.floorNumber !== "" ? `${viewItem.floorNumber}${viewItem.totalFloors ? ` of ${viewItem.totalFloors}` : ""}` : ""],
                ]} />
                <Info title="Apartment details" rows={[
                  ["Type", viewItem.apartmentType], ["Furnishing", viewItem.furnishing], ["Room type", viewItem.roomType],
                  ["Carpet area", viewItem.carpetArea ? `${viewItem.carpetArea} sq ft` : ""], ["Super area", viewItem.superArea ? `${viewItem.superArea} sq ft` : ""],
                  ["Bedrooms", viewItem.bedrooms], ["Hall", viewItem.hall], ["Kitchen", viewItem.kitchen],
                  ["Bathrooms", viewItem.bathrooms], ["Balcony", viewItem.balcony], ["Max guests", viewItem.maxGuests], ["Beds", viewItem.beds],
                ]} />
                <Info title="Pricing" rows={[
                  ["Base price", inr(viewItem.pricing?.basePrice) + " per night"],
                  ["Weekend price", viewItem.pricing?.weekendPrice ? inr(viewItem.pricing.weekendPrice) : ""],
                  ["Monthly price", viewItem.pricing?.monthlyPrice ? inr(viewItem.pricing.monthlyPrice) : ""],
                  ["Extra guest", viewItem.pricing?.extraGuestPrice ? inr(viewItem.pricing.extraGuestPrice) : ""],
                  ["Cleaning fee", viewItem.pricing?.cleaningFee ? inr(viewItem.pricing.cleaningFee) : ""],
                  ["Security deposit", viewItem.pricing?.securityDeposit ? inr(viewItem.pricing.securityDeposit) : ""],
                ]} />
                <Info title="Timings and policy" rows={[
                  ["Check-in", viewItem.checkInTime], ["Check-out", viewItem.checkOutTime],
                  ["Available from", dateOnly(viewItem.availableFrom)], ["Available to", dateOnly(viewItem.availableTo)],
                  ["Meal plan", viewItem.mealPlan], ["Cancellation", viewItem.cancellationPolicy],
                  ["Extra mattress", yn(viewItem.extraMattressAllowed)], ["Children", yn(viewItem.childrenAllowed)], ["Pets", yn(viewItem.petsAllowed)],
                ]} />
                <Info title="Food" rows={[
                  ["Kitchen available", yn(viewItem.kitchenAvailable)], ["Self cooking", yn(viewItem.selfCookingAllowed)],
                  ["Veg food", yn(viewItem.vegFoodAvailable)], ["Non-veg", yn(viewItem.nonVegAllowed)],
                ]} />
                <Info title="House rules" rows={Object.keys(RULE_LABELS).map((k) => [RULE_LABELS[k], viewItem.houseRules ? (viewItem.houseRules[k] ? "Allowed" : "Not allowed") : ""])} />
              </div>

              <h4 className="sub">Amenities</h4>
              {viewItem.amenities?.length ? (
                <div className="chips">{viewItem.amenities.map((a) => <span key={a} className="chip on static">{a}</span>)}</div>
              ) : <p className="hint">No amenities listed.</p>}

              {viewItem.notes && (<><h4 className="sub">Internal notes</h4><p className="desc">{viewItem.notes}</p></>)}
            </div>

            <div className="panel-foot">
              <div />
              <div>
                <button className="btn" onClick={() => setViewItem(null)}>Close</button>
                <button className="btn primary" onClick={() => openEdit(viewItem)}>Edit apartment</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ============ DELETE CONFIRM ============ */}
      {deleteItem && (
        <div className="overlay" onMouseDown={() => !deleting && setDeleteItem(null)}>
          <div className="dialog" role="alertdialog" aria-modal="true" onMouseDown={(e) => e.stopPropagation()}>
            <h2>Delete this apartment?</h2>
            <p>&ldquo;{deleteItem.apartmentName}&rdquo; will be removed permanently. This cannot be undone. If you only want to hide it, switch it to inactive instead.</p>
            <div className="dialog-acts">
              <button className="btn" onClick={() => setDeleteItem(null)} disabled={deleting}>Keep apartment</button>
              <button className="btn danger-solid" onClick={confirmDelete} disabled={deleting}>{deleting ? "Deleting..." : "Delete apartment"}</button>
            </div>
          </div>
        </div>
      )}

      {toast && <div className={`toast ${toast.type}`} role="status">{toast.msg}</div>}
    </div>
  );
}

/* ── Sub-components ── */
function Info({ title, rows }) {
  const shown = rows.filter(([, v]) => v !== undefined && v !== null && v !== "");
  if (shown.length === 0) return null;
  return (
    <section className="info">
      <h4>{title}</h4>
      {shown.map(([k, v]) => (
        <div key={k} className="info-row"><span>{k}</span><span>{String(v)}</span></div>
      ))}
    </section>
  );
}

/* ==============================
   STYLES
============================== */
const css = `
@import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,600;9..144,700&family=Outfit:wght@400;500;600&display=swap');
.va{--ink:#0f1f2e;--muted:#5f7183;--line:#e1e8ef;--bg:#f4f8fb;--accent:#0b6e8a;--accent-d:#095a72;--soft:#e3f3f8;--green:#15803d;--danger:#c62828;
  font-family:'Outfit',system-ui,sans-serif;color:var(--ink);background:var(--bg);min-height:100vh;max-width:1360px;margin:0 auto;padding:32px 24px 64px}
.va *{box-sizing:border-box}
.va h1,.va h2,.va h3{margin:0}
.va h1,.va h2{font-family:'Fraunces',Georgia,serif;letter-spacing:-.01em}
.va button{font-family:inherit}
.va button:focus-visible,.va input:focus-visible,.va select:focus-visible,.va textarea:focus-visible,.va .switch:focus-within,.va .check:focus-within,.va .photo.add:focus-within{outline:2px solid var(--accent);outline-offset:2px}

/* hero + stats */
.hero{display:flex;justify-content:space-between;align-items:center;gap:20px;flex-wrap:wrap;padding:28px 32px;border-radius:20px;color:#fff;margin-bottom:18px;
  background:linear-gradient(120deg,#0b6e8a 0%,#0a8aa0 55%,#17a2a8 100%);box-shadow:0 10px 30px rgba(11,110,138,.22)}
.hero h1{font-size:34px;line-height:1.1;margin:6px 0 8px}
.hero p{margin:0;opacity:.9;font-size:15px}
.eyebrow{font-size:12px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;opacity:.8}
.stats{display:grid;grid-template-columns:repeat(3,1fr);gap:14px;margin-bottom:22px}
.stat{background:#fff;border:1px solid var(--line);border-radius:14px;padding:16px 20px;display:flex;flex-direction:column;gap:6px}
.stat span{font-size:13px;color:var(--muted)}
.stat strong{font:700 30px 'Fraunces',serif;line-height:1}
.stat .g{color:var(--green)}.stat .m{color:#8895a3}

/* buttons */
.btn{border:1px solid var(--line);background:#fff;color:var(--ink);padding:10px 18px;border-radius:10px;font-weight:600;font-size:14px;cursor:pointer;transition:background .15s,border-color .15s}
.btn:hover:not(:disabled){border-color:#b8c7d4;background:#fafcfd}
.btn.sm{padding:7px 13px;font-size:13px}
.btn.lg{padding:13px 24px;font-size:15px}
.btn.primary{background:var(--accent);border-color:var(--accent);color:#fff}
.hero .btn.primary{background:#fff;border-color:#fff;color:var(--accent-d)}
.btn.primary:hover:not(:disabled){background:var(--accent-d);border-color:var(--accent-d)}
.hero .btn.primary:hover:not(:disabled){background:#eaf7fa;border-color:#eaf7fa}
.btn.soft{background:var(--soft);border-color:#bfe3ee;color:var(--accent-d)}
.btn.danger{color:var(--danger);border-color:#f0c9c9}
.btn.danger:hover:not(:disabled){background:#fff5f5}
.btn.danger-solid{background:var(--danger);border-color:var(--danger);color:#fff}
.btn:disabled{opacity:.6;cursor:not-allowed}

/* toolbar */
.toolbar{display:flex;gap:12px;align-items:center;flex-wrap:wrap;margin-bottom:20px}
.toolbar input{flex:1;min-width:230px;padding:11px 16px;border:1.5px solid var(--line);border-radius:10px;font:15px 'Outfit',sans-serif;background:#fff}
.toolbar input:focus{border-color:var(--accent);outline:none;box-shadow:0 0 0 3px rgba(11,110,138,.12)}
.seg{display:inline-flex;background:#fff;border:1.5px solid var(--line);border-radius:10px;padding:3px}
.seg button{border:0;background:none;padding:7px 16px;border-radius:7px;font-weight:600;font-size:13px;color:var(--muted);cursor:pointer}
.seg button.on{background:var(--accent);color:#fff}
.count{font-size:13px;color:var(--muted)}

/* states */
.state{background:#fff;border:1.5px dashed #bfd3e0;border-radius:16px;padding:64px 20px;text-align:center;color:var(--muted);display:flex;flex-direction:column;align-items:center;gap:14px}
.state p{margin:0;font-size:15px}
.state.err{color:var(--danger)}
.empty-ico{width:64px;height:64px;border-radius:50%;background:var(--soft);color:var(--accent);display:grid;place-items:center;font-size:30px}
.spinner{width:38px;height:38px;border:3px solid #cfe6ee;border-top-color:var(--accent);border-radius:50%;animation:va-spin 1s linear infinite}
@keyframes va-spin{to{transform:rotate(360deg)}}

/* cards */
.cards{display:grid;grid-template-columns:repeat(auto-fill,minmax(310px,1fr));gap:20px}
.card{background:#fff;border:1px solid var(--line);border-radius:18px;overflow:hidden;display:flex;flex-direction:column;transition:box-shadow .2s,transform .2s}
.card:hover{box-shadow:0 12px 30px rgba(15,31,46,.1);transform:translateY(-2px)}
.card.off .card-img img{filter:grayscale(.85) brightness(.9)}
.card-img{position:relative;display:block;width:100%;height:200px;padding:0;border:0;background:var(--soft);cursor:pointer;overflow:hidden}
.card-img img{width:100%;height:100%;object-fit:cover;transition:transform .4s}
.card:hover .card-img img{transform:scale(1.04)}
.noimg{display:grid;place-items:center;height:100%;color:var(--muted);font-size:13px}
.pill{position:absolute;top:12px;font-size:12px;font-weight:600;padding:4px 11px;border-radius:999px}
.pill.type{left:12px;background:rgba(255,255,255,.95);color:var(--accent-d)}
.pill.paused{right:12px;background:rgba(15,31,46,.82);color:#fff}
.price{position:absolute;left:0;right:0;bottom:0;padding:26px 14px 10px;text-align:left;color:#fff;font:700 20px 'Fraunces',serif;background:linear-gradient(transparent,rgba(8,20,30,.78))}
.price small{font:400 12px 'Outfit',sans-serif;opacity:.9}
.card-body{padding:16px 18px 6px;flex:1}
.card-body h3{font:600 17px 'Outfit',sans-serif;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.loc{margin:4px 0 12px;font-size:13px;color:var(--muted)}
.specs{list-style:none;margin:0;padding:0;display:flex;flex-wrap:wrap;gap:6px}
.specs li{font-size:12px;font-weight:500;background:#f1f6f9;color:#40586b;padding:4px 10px;border-radius:999px}
.card-foot{display:flex;justify-content:space-between;align-items:center;gap:10px;flex-wrap:wrap;padding:14px 18px;border-top:1px solid #eef2f6;margin-top:12px}
.acts{display:flex;gap:6px}

/* switch */
.switch{display:inline-flex;align-items:center;gap:9px;cursor:pointer;position:relative}
.switch input{position:absolute;opacity:0;width:0;height:0}
.track{width:40px;height:22px;border-radius:999px;background:#c5d0da;position:relative;transition:background .2s;flex:none}
.track::after{content:"";position:absolute;top:3px;left:3px;width:16px;height:16px;border-radius:50%;background:#fff;transition:transform .2s;box-shadow:0 1px 3px rgba(0,0,0,.25)}
.switch input:checked + .track{background:var(--green)}
.switch input:checked + .track::after{transform:translateX(18px)}
.sw-text{font-size:13px;font-weight:600;color:var(--muted)}
.switch input:checked ~ .sw-text{color:var(--green)}

/* full page panels */
.page-wrap{max-width:1080px;margin:0 auto}
.back{background:none;border:0;padding:6px 0;margin-bottom:12px;font-weight:600;font-size:14px;color:var(--accent);cursor:pointer}
.back:hover{text-decoration:underline}
.panel{background:#fff;border:1px solid var(--line);border-radius:20px;box-shadow:0 6px 24px rgba(15,31,46,.06)}
.panel-head{display:flex;justify-content:space-between;align-items:center;gap:16px;padding:22px 30px;position:sticky;top:0;z-index:6;background:#fff;border-radius:20px 20px 0 0}
.panel-head h2{font-size:25px}
.panel-head p{margin:4px 0 0;font-size:14px;color:var(--muted)}
.step-count{font-size:13px;font-weight:600;color:var(--accent-d);background:var(--soft);padding:6px 14px;border-radius:999px;white-space:nowrap}
.progress{height:4px;background:#e9f0f5;position:sticky;top:78px;z-index:6}
.progress i{display:block;height:100%;background:linear-gradient(90deg,var(--accent),#17a2a8);transition:width .3s}
.form-layout{display:grid;grid-template-columns:250px 1fr;min-height:480px}
.steps{padding:20px 14px;border-right:1px solid #eef2f6;display:flex;flex-direction:column;gap:4px}
.step{display:flex;align-items:center;gap:12px;text-align:left;padding:10px 12px;border:0;border-radius:12px;background:none;cursor:pointer}
.step:hover{background:#f4f8fb}
.step.on{background:var(--soft)}
.num{width:28px;height:28px;border-radius:50%;flex:none;display:grid;place-items:center;font-size:13px;font-weight:600;background:#e9f0f5;color:var(--muted)}
.step.on .num{background:var(--accent);color:#fff}
.step.done .num{background:#d6f0e0;color:var(--green)}
.st{display:flex;flex-direction:column;min-width:0}
.st b{font-size:14px;font-weight:600;color:var(--ink)}
.st small{font-size:12px;color:var(--muted);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.form-main{padding:26px 30px}
.step-title{font:600 20px 'Fraunces',serif;margin-bottom:18px}
.form-error{background:#fdecec;color:#a32020;border:1px solid #f6c7c7;border-radius:10px;padding:11px 15px;font-size:14px;margin-bottom:16px}
.grid{display:grid;grid-template-columns:repeat(2,1fr);gap:16px}
.grid.checks{grid-template-columns:repeat(auto-fit,minmax(230px,1fr))}
.full{grid-column:1/-1}
.lbl{display:block;font-size:13px;font-weight:600;color:#33485a;margin-bottom:6px}
.sub{margin:22px 0 10px;font-size:14px;font-weight:600;color:var(--accent-d)}
.grid .sub:first-child{margin-top:0}
.panel input[type=text],.panel input[type=tel],.panel input[type=email],.panel input[type=number],.panel input[type=date],.panel input[type=time],.panel select,.panel textarea{
  width:100%;padding:11px 14px;border:1.5px solid var(--line);border-radius:10px;font:15px 'Outfit',sans-serif;background:#fff;color:var(--ink)}
.panel textarea{resize:vertical}
.panel input:focus,.panel select:focus,.panel textarea:focus{border-color:var(--accent);box-shadow:0 0 0 3px rgba(11,110,138,.12);outline:none}
.check{display:flex;align-items:center;gap:10px;padding:13px 15px;border:1.5px solid var(--line);border-radius:12px;font-size:14px;cursor:pointer;background:#fff;transition:background .15s,border-color .15s}
.check.on{background:#eef8fb;border-color:#8fcfe0}
.check input{width:17px;height:17px;accent-color:var(--accent)}
.check.rule em{margin-left:auto;font-style:normal;font-size:12px;font-weight:600;color:var(--muted)}
.check.rule.on em{color:var(--accent-d)}
.hint{font-size:13px;color:var(--muted);margin:12px 0}
.summary{margin-top:20px;background:#eef8fb;border:1px solid #bfe3ee;border-radius:12px;padding:15px 18px;display:flex;flex-direction:column;gap:4px;font-size:14px}
.summary strong{color:var(--accent-d);margin-bottom:4px}
.chips{display:flex;flex-wrap:wrap;gap:10px}
.chip{padding:9px 18px;border:1.5px solid var(--line);border-radius:999px;background:#fff;font-weight:500;font-size:13px;color:#46596a;cursor:pointer;transition:all .15s}
.chip:hover{border-color:var(--accent);color:var(--accent)}
.chip.on{background:var(--accent);border-color:var(--accent);color:#fff}
.chip.static{cursor:default;padding:6px 14px}
.photos{display:grid;grid-template-columns:repeat(auto-fill,130px);gap:16px}
.photo{width:130px;height:104px;border-radius:12px;position:relative;background:var(--soft)}
.photo img{width:100%;height:100%;object-fit:cover;border-radius:12px}
.photo.add{border:2px dashed #8fcfe0;background:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;font-size:12px;color:var(--muted);cursor:pointer}
.photo.add span{font-size:28px;line-height:1;color:var(--accent)}
.rm{position:absolute;top:-8px;right:-8px;width:26px;height:26px;border-radius:50%;border:2px solid #fff;background:var(--danger);color:#fff;font-size:16px;line-height:1;cursor:pointer;box-shadow:0 2px 6px rgba(0,0,0,.25)}
.badge{position:absolute;left:8px;bottom:8px;background:var(--accent);color:#fff;font-size:11px;font-weight:600;padding:2px 9px;border-radius:5px}
.badge.new{background:var(--green)}
.panel-foot{display:flex;justify-content:space-between;align-items:center;gap:12px;flex-wrap:wrap;padding:16px 30px;border-top:1px solid #eef2f6;background:#fff;position:sticky;bottom:0;z-index:6;border-radius:0 0 20px 20px;box-shadow:0 -6px 16px rgba(15,31,46,.05)}
.panel-foot>div{display:flex;gap:8px;flex-wrap:wrap}

/* view */
.view-body{padding:6px 30px 28px}
.gallery{margin-bottom:18px}
.gallery .main{width:100%;max-height:400px;object-fit:cover;border-radius:16px;display:block;background:var(--soft)}
.strip{display:flex;gap:8px;margin-top:10px;overflow-x:auto;padding-bottom:4px}
.strip button{border:2px solid transparent;border-radius:10px;padding:0;background:none;cursor:pointer;flex:none;opacity:.65}
.strip button.on{border-color:var(--accent);opacity:1}
.strip img{width:92px;height:66px;object-fit:cover;border-radius:8px;display:block}
.price-line{display:flex;align-items:baseline;gap:8px;flex-wrap:wrap;margin-bottom:12px}
.price-line strong{font:700 28px 'Fraunces',serif;color:var(--accent-d)}
.price-line span{color:var(--muted);font-size:14px}
.price-line em{font-style:normal;font-size:13px;font-weight:600;background:var(--soft);color:var(--accent-d);padding:3px 11px;border-radius:999px}
.desc{margin:0 0 18px;font-size:15px;line-height:1.65;color:#37495a;white-space:pre-line}
.view-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:16px}
.info{border:1px solid var(--line);border-radius:14px;padding:15px 18px;background:#fcfdfe}
.info h4{margin:0 0 8px;font-size:14px;color:var(--accent-d)}
.info-row{display:flex;justify-content:space-between;gap:14px;padding:6px 0;font-size:13px;border-bottom:1px solid #f0f4f7}
.info-row:last-child{border-bottom:0}
.info-row span:first-child{color:var(--muted);flex:none}
.info-row span:last-child{text-align:right;word-break:break-word;font-weight:500}

/* dialog + toast */
.overlay{position:fixed;inset:0;background:rgba(10,22,32,.55);display:flex;align-items:center;justify-content:center;padding:20px;z-index:1000;backdrop-filter:blur(3px)}
.dialog{background:#fff;border-radius:18px;width:100%;max-width:440px;padding:28px;box-shadow:0 24px 70px rgba(10,22,32,.35)}
.dialog h2{font-size:22px;margin-bottom:10px}
.dialog p{margin:0 0 22px;font-size:14px;line-height:1.6;color:#45596a}
.dialog-acts{display:flex;justify-content:flex-end;gap:8px;flex-wrap:wrap}
.toast{position:fixed;top:20px;right:20px;z-index:2000;padding:13px 20px;border-radius:12px;font-size:14px;font-weight:500;color:#fff;background:var(--green);box-shadow:0 8px 28px rgba(10,22,32,.25)}
.toast.err{background:var(--danger)}

@media (max-width:820px){
  .form-layout{grid-template-columns:1fr}
  .steps{flex-direction:row;overflow-x:auto;border-right:0;border-bottom:1px solid #eef2f6;padding:12px 14px}
  .step{flex:none}.st small{display:none}
  .progress{top:74px}
}
@media (max-width:640px){
  .va{padding:16px 12px 48px}
  .hero{padding:22px 20px}.hero h1{font-size:28px}
  .stats{gap:8px}.stat{padding:12px 14px}.stat strong{font-size:24px}
  .grid,.view-grid{grid-template-columns:1fr}
  .panel-head,.form-main,.view-body,.panel-foot{padding-left:16px;padding-right:16px}
  .cards{grid-template-columns:1fr}
}
@media (prefers-reduced-motion:reduce){.spinner{animation-duration:3s}.card,.card-img img,.track,.track::after{transition:none}}
`;